var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.32,81.54a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,88.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,178.32,88.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,103.09a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,95.91a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,178.32,95.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,117.46a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,178.32,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,110.28a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,178.32,110.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,124.64a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,178.32,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,178.32,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,178.32,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,139a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,178.32,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,178.32,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,178.32,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,178.32,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,178.32,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,178.32,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,178.32,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,92.32a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,174.73,92.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,85.13a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,99.5a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,174.73,99.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,121.05a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,113.87a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,174.73,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,106.68a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,174.73,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,174.73,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,135.42a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,174.73,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,174.73,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,157a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,142.6a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,174.73,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,174.73,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,174.73,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,174.73,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,174.73,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,228.79l-1.2,0-1.17,0a1.19,1.19,0,0,1,1.17-1.1A1.2,1.2,0,0,1,174.73,228.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,174.73,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,88.73a1.19,1.19,0,0,1-1.2,1.19,1.18,1.18,0,0,1-1-.64l1.28-1.7A1.18,1.18,0,0,1,171.14,88.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,103.09a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,171.14,103.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.94,
    cy: 95.91,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,171.14,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.94,
    cy: 117.46,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,124.64a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,171.14,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,110.28a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,171.14,110.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,171.14,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.94,
    cy: 174.93,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.94,
    cy: 153.38,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,171.14,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,171.14,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,171.14,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,160.56a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,171.14,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,139a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,171.14,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,171.14,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,171.14,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.23,91.52a1.19,1.19,0,0,1-.88,2,1.28,1.28,0,0,1-.52-.12l.52-.69.28-.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,171.14,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,171.14,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.94,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,128.24a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,167.54,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,149.79a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,167.54,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,167.54,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,106.68a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,167.54,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,99.5a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,167.54,99.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,167.54,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,135.42a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,167.54,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,142.6a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,167.54,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,121.05a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,167.54,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,113.87a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.49,228.52l-1.14,0-1.12,0a1.17,1.17,0,0,1,1.12-.83A1.19,1.19,0,0,1,167.49,228.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,167.54,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,167.54,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,167.54,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,131.83a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,103.09a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,164,103.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,167.75a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,117.46a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,164,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,146.2a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,110.28a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.1,97l.85-1.13A1.19,1.19,0,0,1,163.1,97Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,164,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,164,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,139a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,164,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,124.64a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,164,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,164,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,160.36,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,164,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,135.42a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,160.36,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,164,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,164,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,106.68a1.2,1.2,0,1,1-1.2-1.19A1.19,1.19,0,0,1,160.36,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,164,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,113.87a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,160.36,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,121.05a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,160.36,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,142.6a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,160.36,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,160.36,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,157a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,160.36,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,160.36,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,160.36,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,160.36,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,160.36,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,160.36,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,160.36,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,160.36,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.21,228.25l-1.05,0-1,0a1.17,1.17,0,0,1,1-.57A1.21,1.21,0,0,1,160.21,228.25Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,160.36,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,160.36,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,181.91,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,228.81a1,1,0,0,1,0,.25l-1.14,0-1.17-.05c0-.05,0-.1,0-.16a1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,181.91,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,181.91,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.98,
    cy: 192.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,156.77,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,156.77,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,164.16A1.2,1.2,0,1,1,152,163,1.19,1.19,0,0,1,153.18,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,156.77,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,156.77,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.98,
    cy: 171.34,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,153.18,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,142.6a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,153.18,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,124.64a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,153.18,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,117.46a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,156.77,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,156.77,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,156.77,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,113.87a1.2,1.2,0,1,1-2.11-.75l.08-.11a1.2,1.2,0,0,1,2,.86Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,139a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,128.24A1.2,1.2,0,1,1,152,127,1.19,1.19,0,0,1,153.18,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,121.05a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,153.18,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,153.18,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,153.18,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,156.77,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,156.77,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,156.77,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,157a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,153.18,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.98,
    cy: 135.42,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,110.28a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,156.77,110.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,153.18,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,153.18,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,156.77,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,153.18,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,181.91,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,142.6a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,181.91,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,135.42a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,181.91,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,181.91,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,181.91,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,149.79a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,181.91,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,124.64a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,149.59,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.39,
    cy: 153.38,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,149.59,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,227.61a1.18,1.18,0,0,1,.86.37l-.86,0-.78,0A1.16,1.16,0,0,1,152,227.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,160.56a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,149.59,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,139a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,149.59,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,149.59,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,149.59,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,117.46a1.2,1.2,0,0,1-1.2,1.2,1.17,1.17,0,0,1-1-.6l1.29-1.74A1.19,1.19,0,0,1,149.59,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,149.59,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.39,
    cy: 174.93,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,128.24a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,85.13a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,181.91,85.13Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,185.5,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,185.5,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,99.5a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,181.91,99.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,121.05a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,181.91,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,185.5,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,113.87a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,106.68a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,181.91,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,78a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,181.91,78Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,92.32a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.49,67.11s0,0,0,.06a1.18,1.18,0,0,1-.91,1.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,131.83a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,139a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,185.5,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,95.91a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,185.5,95.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,88.73a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,185.5,88.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,81.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,185.5,81.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,103.09a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,185.5,103.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,117.46a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,185.5,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,146.2a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,167.75a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,185.5,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,185.5,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,185.5,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,185.5,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,110.28a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,74.36a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,124.64a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,185.5,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,149.59,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,146,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,149.59,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,128.24a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,149.59,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.7,120.29a1.16,1.16,0,0,1,.29.76,1.19,1.19,0,0,1-1.19,1.2,1.29,1.29,0,0,1-.48-.1l.48-.65.34-.45Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,146,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,142.6a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,146,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,149.79a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,146,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,135.42a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,146,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,146,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,146,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.39,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,146,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,149.59,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,149.59,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,146,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,189.1,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,189.1,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,189.1,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 192.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,189.1,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,189.1,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,228.81a1.2,1.2,0,0,1-.13.51l-1.07,0-1.11,0a1.22,1.22,0,0,1-.09-.43,1.2,1.2,0,1,1,2.4,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 171.34,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,189.1,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,157a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,189.1,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,189.1,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,142.4,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,138.81,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,142.4,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,189.3a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,142.4,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,135.42a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,138.81,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,167.75a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,142.4,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.8,227.61a1.23,1.23,0,0,1,.39.08h-.66A1.18,1.18,0,0,1,144.8,227.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,142.6a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,203.67a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,142.4,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,142.4,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,131.83a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,142.4,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,142.4,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,139a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,142.4,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,146.2a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,142.4,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.62,125.76l.76-1A1.16,1.16,0,0,1,141.62,125.76Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,142.4,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,142.4,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,225.22a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,142.4,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,142.4,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 99.5,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,113.87a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,189.1,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,189.1,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,142.6a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,189.1,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,92.32a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,189.1,92.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 135.42,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,189.1,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,106.68a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,189.1,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,121.05a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,189.1,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,67.17a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,192.69,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,192.69,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,139a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,95.91a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,192.69,95.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,81.54a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,192.69,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,192.69,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,192.69,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,192.69,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 77.95,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,192.69,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.75,62.75a1.19,1.19,0,0,1,.35.83,1.2,1.2,0,0,1-1.2,1.2,1.16,1.16,0,0,1-.55-.15l.55-.74.23-.31Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,88.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,192.69,88.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,74.36a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,192.69,74.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,192.69,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,103.09a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,70.77a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,189.1,70.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,117.46a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,192.69,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,124.64a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,85.13a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,189.1,85.13Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,192.69,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,110.28a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,192.69,110.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,192.69,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,138.81,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,138.81,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,138.81,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,138.81,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,138.81,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,138.81,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,157a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,135.22,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.43,
    cy: 171.34,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,135.22,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,131.63,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.43,
    cy: 192.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,135.22,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,135.22,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,225.22A1.2,1.2,0,1,1,134,224,1.19,1.19,0,0,1,135.22,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,131.63,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,131.63,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,135.22,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,135.22,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,146.2A1.2,1.2,0,1,1,134,145,1.19,1.19,0,0,1,135.22,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,135.22,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,139a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,131.63,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,131.63,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,157a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,131.63,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,131.63,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,142.6a1.2,1.2,0,1,1-2.4,0,1.11,1.11,0,0,1,.09-.4l.39-.53a1.18,1.18,0,0,1,1.92.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,131.63,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,131.63,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.13,154.47l.68-.91A1.16,1.16,0,0,1,120.13,154.47Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,124.44,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,128,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,128,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.18,149.07a1.17,1.17,0,0,1-.93,1.91,1.27,1.27,0,0,1-.44-.08l.44-.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,124.44,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,124.44,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,128,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,124.44,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,124.44,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,128,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,128,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,120.85,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,128,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,167.75a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,120.85,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,124.44,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,128,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,146.2a1.18,1.18,0,0,1-2.18.63l1.32-1.76A1.16,1.16,0,0,1,128,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,120.85,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,124.44,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,120.85,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,113.67,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,117.26,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,120.85,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,117.26,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,113.67,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.47,
    cy: 174.93,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,113.67,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,113.67,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,120.85,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,117.26,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,117.26,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,113.67,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,120.85,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,117.26,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,117.26,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,199.87,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,199.87,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,199.87,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,199.87,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,199.87,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,63.58a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,92.32a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,196.28,92.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,70.77a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,196.28,70.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,99.5a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,196.28,99.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,85.13a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,78a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,196.28,78Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.89,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,102.89,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,106.48,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,106.48,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.89,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,102.89,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.65,177.84a1.17,1.17,0,0,1,.24.68,1.2,1.2,0,0,1-1.2,1.2,1.23,1.23,0,0,1-.38-.08l.38-.52.45-.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48,225.22a1.18,1.18,0,0,1-.59,1l-1.28,0a1.18,1.18,0,0,1-.52-1,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.47,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.89,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,102.89,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.89,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,102.89,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.89,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,102.89,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.89,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,102.89,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,110.07,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48,174.93a1.18,1.18,0,0,1-2.16.67l1.35-1.79A1.18,1.18,0,0,1,106.48,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,113.67,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,110.07,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,110.07,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,106.48,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,106.48,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,110.07,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,171.34a1.2,1.2,0,1,1-2.39,0,1.55,1.55,0,0,1,.06-.31l.53-.69a1.08,1.08,0,0,1,.61-.2A1.19,1.19,0,0,1,110.07,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,113.67,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,113.87a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,196.28,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,106.68a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,196.28,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,135.42a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,196.28,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,121.05a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,196.28,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,142.6a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,196.28,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,196.28,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,196.28,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,196.28,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,157a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,196.28,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,196.28,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,224.91l-2.25-.09a1.19,1.19,0,0,1,1.12-.8A1.18,1.18,0,0,1,70.5,224.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.93,225.22a1.43,1.43,0,0,1,0,.22l-2.32-.08a.7.7,0,0,1,0-.14,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,88.52,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.34,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.51,
    cy: 192.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,200.07a1.2,1.2,0,1,1-2.39,0,1.42,1.42,0,0,1,0-.2l.65-.87a1.13,1.13,0,0,1,.51-.12A1.19,1.19,0,0,1,88.52,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.11,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,92.11,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.11,225.22a1.17,1.17,0,0,1-.11.49l-2.19-.08a1.16,1.16,0,0,1-.09-.41,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.69,183.13l.55-.73A1.14,1.14,0,0,1,98.69,183.13Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.16,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,74.16,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.11,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,92.11,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,99.3,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,95.71,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3,225.22A1.19,1.19,0,0,1,99,226l-1.86-.07a1.14,1.14,0,0,1-.24-.68,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.93,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,84.93,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.75,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,77.75,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,95.71,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,95.71,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.13,206.61a1.22,1.22,0,0,1,.21.65,1.19,1.19,0,0,1-1.2,1.19,1.28,1.28,0,0,1-.34-.06l.34-.46.5-.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.74,225.18l-2.36-.09a1.18,1.18,0,0,1,2.36.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.93,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,84.93,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.93,203.67a1.18,1.18,0,0,1-2.13.71l1.36-1.82A1.19,1.19,0,0,1,84.93,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.11,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,92.11,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,99.3,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,95.71,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,99.3,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.34,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,81.34,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.25,211.79l.42-.56A1.18,1.18,0,0,1,77.25,211.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.11,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,60a1.2,1.2,0,0,1-1.2,1.2,1.17,1.17,0,0,1-1.06-.68l1.25-1.68A1.19,1.19,0,0,1,192.69,60Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,196.28,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,228.81a1.2,1.2,0,0,1-.3.78l-.9,0-.93,0a1.13,1.13,0,0,1-.26-.71,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,203.46,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.16,64l1.11.64.17.1a1,1,0,0,1-.17,0A1.19,1.19,0,0,1,201.16,64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,110.28a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,149.79a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.86,
    cy: 153.38,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,70.77a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,207.06,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,207.06,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,106.68a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,203.46,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,207.06,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,121.05a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,203.46,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,74.36a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,207.06,74.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,203.46,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.66,67.17a1.16,1.16,0,0,1,.43-.89L207,67.39a1.18,1.18,0,0,1-1.15,1A1.2,1.2,0,0,1,204.66,67.17Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,110.28a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,207.06,110.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,81.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,199.87,81.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,85.13a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,203.46,85.13Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,135.42a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,203.46,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,228.81a1.18,1.18,0,0,1-.62,1l-.57,0-.64,0a1.19,1.19,0,0,1-.56-1,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,88.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,207.06,88.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.86,
    cy: 117.46,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,167.75a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.86,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,103.09a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,199.87,103.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,160.56a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,207.06,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,146.2a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,88.73a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,199.87,88.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,78a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,203.46,78Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,99.5a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,203.46,99.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,207.06,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,203.46,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,128.24a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,203.46,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,95.91a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,199.87,95.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,139a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,199.87,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,203.46,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,142.6a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,203.46,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,103.09a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,207.06,103.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.86,
    cy: 174.93,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,207.06,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,117.46a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,199.87,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,67.17A1.2,1.2,0,1,1,198.68,66,1.19,1.19,0,0,1,199.87,67.17Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,203.46,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,207.06,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,139a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,207.06,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,124.64a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,199.87,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,207.06,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,207.06,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,199.87,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,131.83a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,113.87a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,199.87,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,81.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,207.06,81.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,124.64a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,207.06,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,203.46,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,92.32a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,74.36a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.06,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,207.06,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.86,
    cy: 95.91,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,210.65,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,117.46a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,214.24,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,95.91a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,214.24,95.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,139a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,210.65,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,78a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,210.65,78Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,217.83,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,185.71a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,99.5a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,210.65,99.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,214.24,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,70.77a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,210.65,70.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,142.6a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,217.83,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,149.79a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,124.64a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,210.65,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,214.24,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,217.83,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,210.65,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,221.63a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,214.24,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,110.28a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,214.24,110.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,210.65,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,210.65,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,210.65,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,214.24,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,214.24,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,142.6a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,217.83,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,214.24,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,88.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,214.24,88.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,92.32a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,210.65,92.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,85.13a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,128.24a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,225.22A1.2,1.2,0,1,1,213,224,1.19,1.19,0,0,1,214.24,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,103.09a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,146.2A1.2,1.2,0,1,1,213,145,1.19,1.19,0,0,1,214.24,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,81.54a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,214.24,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,157a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,74.36a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,214.24,74.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,113.87a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,210.65,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,207.26a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,210.65,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,106.68a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,210.65,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,210.65,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,135.42a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,121.05a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,135.42a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,210.65,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,217.83,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.24,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,214.24,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,221.42,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,225,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,228.61,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,88.73a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,221.42,88.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.82,
    cy: 135.42,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,77.81s0,.09,0,.14a1.2,1.2,0,0,1-2.4,0,1.19,1.19,0,0,1,.72-1.09l.48.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,160.56a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,228.61,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,121.05a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,225,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,146.2a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,85.13a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,225,85.13Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,228.61,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,103.09a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,228.61,103.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.41,
    cy: 153.38,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,221.42,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,225,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,228.61,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,121.05a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,217.83,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,74.36l1.77,1a1.22,1.22,0,0,1-.57.16A1.19,1.19,0,0,1,219,74.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,124.64a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,221.42,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,124.64a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,228.61,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,142.6a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,225,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.41,
    cy: 117.46,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,95.91a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,221.42,95.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,228.61,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,225,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,103.09a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,221.42,103.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,110.28a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,106.68a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,217.83,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,113.87a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,225,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,157a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,225,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,225,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,225,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.41,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,78a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,78Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,221.42,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,99.5a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,99.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,228.61,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,113.87a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,81.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,221.42,81.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.41,
    cy: 174.93,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,225,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,228.61,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.41,
    cy: 95.91,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.82,
    cy: 171.34,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,85.13a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,217.83,85.13Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,92.32a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,217.83,92.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,167.75a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,131.83a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,221.42,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,228.61,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,221.42,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,117.46a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,221.42,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.82,
    cy: 192.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,110.28a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,228.61,110.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,228.61,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,139a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,221.42,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,221.42,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,92.32a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,225,92.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,139a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,228.61,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,225,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,225,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,228.61,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.82,
    cy: 99.5,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.82,
    cy: 228.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,221.42,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,106.68a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,225,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,225,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,182.11a1.2,1.2,0,1,1-1.2-1.19A1.19,1.19,0,0,1,235.79,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,232.2,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,239.38,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,135.42a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,232.2,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,157a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,81.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,228.61,81.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,85.13a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,232.2,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,164.16A1.2,1.2,0,1,1,231,163,1.19,1.19,0,0,1,232.2,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,235.79,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,128.24A1.2,1.2,0,1,1,231,127,1.19,1.19,0,0,1,232.2,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,232.2,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,235.79,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,160.56a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,235.79,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,232.2,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,106.68a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,232.2,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,232.2,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,235.79,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,92.32a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,232.2,92.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,235.79,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,113.87a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,232.2,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,142.6a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,235.79,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,235.79,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,232.2,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,235.79,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,235.79,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,99.5a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,232.2,99.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.61,88.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,228.61,88.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,239.38,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,239.38,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,232.2,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,121.05a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,85.13a1.14,1.14,0,0,1,.07-.32l.56.32.57.33.85.5a1.16,1.16,0,0,1-.85.37A1.2,1.2,0,0,1,237,85.13Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,88.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,235.79,88.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,103.09a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,235.79,103.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,95.91a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,235.79,95.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,110.28a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,235.79,110.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,117.46a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,235.79,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,124.64a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,235.79,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,235.79,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,235.79,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,139a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,235.79,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,235.79,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,239.38,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,239.38,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,239.38,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,239.38,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,239.38,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,149.79a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,142.6a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,239.38,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,135.42a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,239.38,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,128.24a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,121.05a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,239.38,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,113.87a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,106.68a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,239.38,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,99.5a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,239.38,99.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,92.32a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,243,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,243,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,243,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,243,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,243,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,167.75a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,243,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,243,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,146.2a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,139a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,243,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,131.83a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,124.64a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,243,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,117.46a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,243,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,110.28a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,103.09a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,243,103.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,95.91a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,243,95.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.78,231.21a1.29,1.29,0,0,1,.48.1l-.85,0A1.16,1.16,0,0,1,241.78,231.21Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.8,88.14a1.16,1.16,0,0,1,.17.59,1.2,1.2,0,0,1-2.39,0,1.21,1.21,0,0,1,1.18-1.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.37,
    cy: 228.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,246.57,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,246.57,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,246.57,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,246.57,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.37,
    cy: 192.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,246.57,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,246.57,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.37,
    cy: 171.34,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,246.57,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,157a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,246.57,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,246.57,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,142.6a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,246.57,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.37,
    cy: 135.42,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,246.57,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,121.05a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,246.57,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,113.87a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,246.57,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,106.68a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,246.57,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.37,
    cy: 99.5,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,92.32a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,246.57,92.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,225.22A1.2,1.2,0,1,1,249,224,1.19,1.19,0,0,1,250.16,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,250.16,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,250.16,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,250.16,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,250.16,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,250.16,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,250.16,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,250.16,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,146.2A1.2,1.2,0,1,1,249,145,1.19,1.19,0,0,1,250.16,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,139a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,250.16,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,124.64a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,117.46a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,250.16,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,110.28a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,250.16,110.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,103.09a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,95.91a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,250.16,95.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,231.21a1.18,1.18,0,0,1,.87.38l-1.68-.06A1.2,1.2,0,0,1,249,231.21Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,253.75,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,253.75,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,253.75,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,253.75,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,253.75,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,253.75,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,253.75,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,157a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,253.75,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,142.6a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,135.42a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,253.75,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,253.75,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,121.05a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,113.87a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,253.75,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,106.68a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,253.75,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,99.5a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,253.75,99.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,257.34,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,257.34,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,257.34,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,257.34,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,257.34,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,167.75a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,257.34,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,257.34,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,146.2a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,139a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,257.34,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,131.83a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,124.64a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,257.34,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,117.46a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,257.34,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,110.28a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,103.09a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,257.34,103.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,95.91a1.22,1.22,0,0,1,.19-.62l2,1.18a1.18,1.18,0,0,1-1,.64A1.2,1.2,0,0,1,255,95.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.2,231.87l-2.06-.08a1.17,1.17,0,0,1,2.06.08Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,260.93,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,260.93,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,260.93,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,260.93,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,260.93,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,260.93,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,260.93,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,260.93,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,149.79a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,142.6a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,260.93,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,135.42a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,260.93,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,128.24a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,121.05a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,260.93,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,113.87a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,106.68a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,260.93,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,99.5a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,260.93,99.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,264.53,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,264.53,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.33,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,264.53,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,264.53,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,264.53,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,264.53,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.33,
    cy: 174.93,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,264.53,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,160.56a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,264.53,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.33,
    cy: 153.38,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,264.53,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,139a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,264.53,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,264.53,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,124.64a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,264.53,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.33,
    cy: 117.46,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,110.28a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,264.53,110.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.49,232.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.49,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,458.49,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.49,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.45,239.37l-2.29-.08a1.17,1.17,0,0,1,1.13-.9A1.19,1.19,0,0,1,458.45,239.37Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.69,214.44a1.27,1.27,0,0,1,.12-.51l.89.51.18.11,1,.56a1.18,1.18,0,0,1-2.16-.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.08,236a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,462.08,236Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.08,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,462.08,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.08,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,462.08,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.67,232.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,465.67,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.67,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.67,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,465.67,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.67,239.59s0,0,0,0l-2.37-.09a1.19,1.19,0,0,1,2.38,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.26,236a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,469.26,236Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.26,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,469.26,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.26,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.86,232.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,472.86,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.86,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,472.86,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.86,239.59a1.23,1.23,0,0,1-.07.32l-2.28-.09a1.89,1.89,0,0,1-.05-.23,1.2,1.2,0,1,1,2.4,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.11,222.79a1.17,1.17,0,0,1-.8-.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.45,236a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.45,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,476.45,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480,232.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480,239.59a1.07,1.07,0,0,1-.18.58l-2.09-.08a1.19,1.19,0,1,1,2.27-.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.65,225.22a1.2,1.2,0,0,1,.3-.78l2,1.17a1.19,1.19,0,0,1-2.31-.39Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.63,236a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,483.63,236Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.63,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,483.63,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.22,232.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,487.22,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.22,239.59a1.15,1.15,0,0,1-.35.84l-1.73-.06a1.16,1.16,0,0,1-.31-.78,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.82,236a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,490.82,236Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.06,232.62l1.55.9a1.35,1.35,0,0,1-.4.08A1.18,1.18,0,0,1,492.06,232.62Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.41,239.59a1.21,1.21,0,0,1-.73,1.1l-1,0a1.19,1.19,0,0,1,.52-2.26A1.2,1.2,0,0,1,494.41,239.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.88,236l.11.06a1.19,1.19,0,1,1-1.82-1.05l.63.37Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.59,239.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,501.59,239.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.39,232.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,415.39,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.39,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,415.39,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.39,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,415.39,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.19,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.39,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,415.39,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.39,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,415.39,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.39,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,415.39,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,236a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,419,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,419,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,419,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,419,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.57,232.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.57,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,422.57,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.57,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.57,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,422.57,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.57,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,422.57,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.57,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.8,193.05l1.17.68.45.26a1.14,1.14,0,0,1-.45.1A1.19,1.19,0,0,1,423.8,193.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.16,236A1.2,1.2,0,1,1,425,234.8,1.19,1.19,0,0,1,426.16,236Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.16,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,426.16,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.16,221.63a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,426.16,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.16,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,426.16,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.16,207.26a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,426.16,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.16,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,426.16,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.75,232.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,429.75,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.75,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.75,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,429.75,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.75,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,429.75,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.75,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,195.47l1.79,1a1.2,1.2,0,0,1-2.39,0A1.17,1.17,0,0,1,428,195.47Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.35,236a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,433.35,236Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.15,
    cy: 228.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.35,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,433.35,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.35,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,433.35,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.35,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,433.35,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.35,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,433.35,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.94,232.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,436.94,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.94,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,436.94,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.94,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,436.94,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.74,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.94,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,436.94,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74,238.39a1.08,1.08,0,0,1,.56.16l-1.06,0A1.19,1.19,0,0,1,435.74,238.39Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.53,236a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.53,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,440.53,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.53,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,440.53,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.53,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.53,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,440.53,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.12,232.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,444.12,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.12,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,444.12,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.12,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,444.12,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.12,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,444.12,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.73,203.67a1.42,1.42,0,0,1,0-.2l1.91,1.1a1.16,1.16,0,0,1-.76.29A1.19,1.19,0,0,1,441.73,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.92,238.39a1.19,1.19,0,0,1,.91.44l-1.77-.07A1.18,1.18,0,0,1,442.92,238.39Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.71,236a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,447.71,236Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.71,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,447.71,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.71,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.71,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,447.71,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.63,206.87a1,1,0,0,1,.08.39,1.2,1.2,0,1,1-1.4-1.16l.21.12Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.3,232.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,451.3,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.3,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.3,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,451.3,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.3,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,451.3,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.2,239.1l-2.13-.08a1.18,1.18,0,0,1,2.13.08Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.9,236a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,454.9,236Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453.7,
    cy: 228.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.9,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,454.9,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.9,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,454.9,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,232.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,386.65,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,386.65,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,386.65,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,386.65,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,386.65,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,386.65,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,386.65,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,182.11a1.2,1.2,0,1,1-1.2-1.19A1.19,1.19,0,0,1,386.65,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,386.65,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,236a1.24,1.24,0,0,1-.33.83l-.86,0-.91,0a1.19,1.19,0,1,1,2.1-.76Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,390.24,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,390.24,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,390.24,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,390.24,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,390.24,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.83,232.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,393.83,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.83,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.83,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,393.83,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.83,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,393.83,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.83,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.83,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,393.83,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.83,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.83,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,393.83,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,174.93a1.16,1.16,0,0,1,.15-.55l2,1.18a1.18,1.18,0,0,1-1,.57A1.2,1.2,0,0,1,391.44,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,236a1.19,1.19,0,0,1-.7,1.08l-.5,0-.56,0a1.19,1.19,0,1,1,1.76-1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.23,
    cy: 228.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,397.43,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,397.43,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,397.43,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,397.43,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.23,
    cy: 192.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,397.43,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,397.43,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,232.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,401,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,401,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,401,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,401,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,401,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.61,236a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.61,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,404.61,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.61,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,404.61,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.61,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.61,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,404.61,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.61,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.61,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,404.61,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.61,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,404.61,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,182.74l1,.57A1.19,1.19,0,0,1,406,182.74Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,232.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,408.2,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,408.2,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,408.2,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,408.2,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.4,185.71a1.17,1.17,0,0,1,.33-.81l.87.5.53.31.59.34a1.17,1.17,0,0,1-1.12.85A1.19,1.19,0,0,1,409.4,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.79,236a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,411.79,236Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.79,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,411.79,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.79,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.79,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,411.79,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.79,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.79,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,411.79,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.79,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,411.79,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,361.51,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,361.51,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,361.51,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,361.51,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,156.94v0a1.2,1.2,0,1,1-2.39,0,1.18,1.18,0,0,1,.64-1l.55.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,232.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,365.1,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,365.1,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,365.1,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,365.1,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,365.1,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,365.1,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,365.1,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,236s0,0,0,0l-.87,0h-.32l-1.18,0a1.19,1.19,0,0,1,2.38.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,368.69,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,368.69,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,368.69,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,368.69,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,368.69,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,368.69,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,368.69,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,368.69,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,368.69,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,368.69,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,232.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,372.28,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,372.28,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,372.28,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,372.28,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,372.28,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,372.28,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,167.75a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.48,164.16a.93.93,0,0,1,0-.24l.42.24.73.42.79.46a1.19,1.19,0,0,1-2-.88Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,236a1,1,0,0,1-.07.3l-1.13,0-1.15,0a.87.87,0,0,1,0-.22,1.2,1.2,0,0,1,2.4,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.68,
    cy: 228.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,375.88,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,375.88,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,375.88,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,375.88,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.68,
    cy: 192.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,375.88,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,375.88,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.68,
    cy: 171.34,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.47,232.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,379.47,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.47,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,379.47,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.47,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,379.47,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.27,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.47,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,379.47,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.47,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,379.47,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.47,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,379.47,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.47,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,379.47,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.27,
    cy: 174.93,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.38,167.3a1.34,1.34,0,0,1,.09.45,1.2,1.2,0,1,1-1.34-1.17Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,236a1.22,1.22,0,0,1-.16.57l-1,0-1.09,0a1.3,1.3,0,0,1-.1-.49,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,383.06,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,383.06,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,383.06,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,383.06,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,383.06,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,383.06,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,157a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,340,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,340,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,232.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,343.55,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,343.55,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,343.55,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,343.55,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,343.55,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,343.55,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,343.55,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,343.55,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.16,146.2a1.23,1.23,0,0,1,.34-.85l2,1.15a1.18,1.18,0,0,1-2.33-.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.94,234.8a1.17,1.17,0,0,1,.89.41l-.89,0-.84,0A1.17,1.17,0,0,1,345.94,234.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,347.14,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,347.14,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,347.14,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,347.14,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,347.14,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,347.14,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,347.14,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,157a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,347.14,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,232.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,350.73,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,225.22a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,350.73,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,350.73,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,350.73,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,203.67a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,350.73,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,350.73,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,189.3a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,350.73,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,350.73,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,350.73,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,167.75a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,350.73,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,350.73,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,350.73,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.2,235.49l-1.07,0-1,0a1.16,1.16,0,0,1,1-.61A1.18,1.18,0,0,1,354.2,235.49Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,354.32,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,354.32,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,354.32,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,354.32,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,354.32,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,354.32,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,354.32,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,354.32,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,232.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,357.92,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,357.92,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,357.92,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.72,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,357.92,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,357.92,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,357.92,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,357.92,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.72,
    cy: 174.93,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,357.92,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,160.56a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,357.92,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.55,153.49l1.67,1a1.16,1.16,0,0,1-1.67-1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.46,235.76l-1.15,0-1.13,0a1.17,1.17,0,0,1,2.28.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,361.51,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,361.51,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,361.51,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,325.59,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,325.59,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,325.59,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,325.59,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,325.59,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,325.59,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,325.59,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,157a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,325.59,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59,142.6a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,232.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,225.22A1.2,1.2,0,1,1,328,224,1.19,1.19,0,0,1,329.18,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,329.18,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,329.18,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,329.18,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,329.18,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,329.18,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,329.18,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,329.18,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,146.2A1.2,1.2,0,1,1,328,145,1.19,1.19,0,0,1,329.18,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,139a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,332.77,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,332.77,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,332.77,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,332.77,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,332.77,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,332.77,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,332.77,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,332.77,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,149.79a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,142.6a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,332.77,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,232.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,336.36,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,336.36,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,336.36,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,336.36,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,336.36,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,336.36,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,167.75a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,336.36,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,336.36,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,146.2a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.72,143.16l1,.6.05,0h-.05A1.19,1.19,0,0,1,337.72,143.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.76,234.8a1.14,1.14,0,0,1,.52.13l-.52,0-.47,0A1.23,1.23,0,0,1,338.76,234.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.76,
    cy: 228.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,340,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,340,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,340,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,340,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.76,
    cy: 192.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,340,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,340,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.76,
    cy: 171.34,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,340,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,307.63,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,307.63,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,307.63,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,307.63,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,307.63,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,307.63,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,307.63,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,307.63,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,139a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,307.63,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.24,124.64a1.37,1.37,0,0,1,.05-.28l2,1.14a1.16,1.16,0,0,1-.83.34A1.19,1.19,0,0,1,305.24,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,311.22,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,311.22,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,311.22,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,311.22,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,311.22,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,311.22,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,311.22,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,311.22,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,311.22,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,164.16A1.2,1.2,0,1,1,310,163,1.19,1.19,0,0,1,311.22,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,157a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,311.22,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,311.22,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,142.6a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,311.22,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,135.42a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,311.22,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1,127.73a1.19,1.19,0,1,1-2.27.51,1.18,1.18,0,0,1,1.11-1.18l.08,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,232.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,314.81,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,314.81,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,314.81,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,314.81,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,314.81,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,314.81,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,167.75a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,314.81,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,314.81,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,146.2a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,139a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,314.81,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,131.83a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,318.4,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,318.4,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,318.4,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,318.4,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,318.4,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,318.4,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,318.4,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,318.4,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,149.79a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,142.6a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,318.4,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,135.42a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,318.4,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,232.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,322,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,322,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,322,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.8,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,322,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,322,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,322,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,322,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.8,
    cy: 174.93,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,322,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,160.56a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,322,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.8,
    cy: 153.38,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,322,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,139a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,322,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.2,135.42a1.13,1.13,0,0,1,.17-.58l1,.58h0l1,.59a1.17,1.17,0,0,1-1,.6A1.19,1.19,0,0,1,323.2,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,289.67,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,142.6a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,135.42a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,289.67,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,289.67,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,121.05a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,225.22a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,293.26,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,293.26,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,293.26,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,203.67a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,293.26,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,293.26,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,189.3a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,293.26,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,293.26,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,293.26,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,167.75a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,293.26,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,293.26,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,293.26,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,146.2a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,293.26,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,139a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,293.26,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,131.83a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,293.26,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,124.64a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,293.26,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.26,232.4a1.15,1.15,0,0,1-.32.8l-1.8-.07a1.17,1.17,0,0,1-.27-.73,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.24,117.38a.24.24,0,0,1,0,.08,1.2,1.2,0,1,1-1.71-1.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,296.85,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,296.85,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,296.85,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,296.85,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,296.85,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,296.85,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,296.85,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,296.85,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,149.79a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,142.6a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,296.85,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,135.42a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,296.85,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,128.24a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,121.05a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,296.85,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,300.45,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,218a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,300.45,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.25,
    cy: 210.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,300.45,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,196.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,300.45,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,300.45,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,300.45,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.25,
    cy: 174.93,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,300.45,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,160.56a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,300.45,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.25,
    cy: 153.38,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,300.45,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,139a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,300.45,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,300.45,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,124.64a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,300.45,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,232.4a1.19,1.19,0,0,1-.67,1.06l-1.13-.05a1.17,1.17,0,0,1-.6-1,1.2,1.2,0,0,1,2.4,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.84,
    cy: 228.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,304,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,304,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,304,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,304,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.84,
    cy: 192.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,304,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,304,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.84,
    cy: 171.34,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,304,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,157a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,304,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,304,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,142.6a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,304,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.84,
    cy: 135.42,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,304,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,232.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,307.63,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,149.79a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,142.6a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,275.3,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,135.42a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,275.3,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,128.24a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,121.05a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,275.3,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,113.87a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,225.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,218a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,278.89,218Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,210.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,278.89,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,203.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,196.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,278.89,196.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,189.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,182.11a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,278.89,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,174.93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,278.89,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,167.75a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,160.56a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,278.89,160.56Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,153.38a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,278.89,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,146.2a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,139a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,278.89,139Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,131.83a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,124.64a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,278.89,124.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,117.46a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,278.89,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,110.28a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,232.4a1.26,1.26,0,0,1-.05.28l-2.3-.09a1.06,1.06,0,0,1,0-.19,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.29,
    cy: 228.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,282.49,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,214.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,282.49,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,282.49,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,200.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,282.49,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.29,
    cy: 192.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,282.49,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,178.52a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,282.49,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.29,
    cy: 171.34,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,282.49,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,157a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,282.49,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,282.49,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,142.6a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,282.49,142.6Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.29,
    cy: 135.42,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,282.49,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,121.05a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,282.49,121.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,113.87a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,282.49,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,286.08,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,286.08,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,286.08,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,286.08,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,286.08,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,286.08,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,286.08,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,286.08,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,286.08,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,139a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,286.08,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,124.64a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,117.46a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,286.08,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,232.4a1.09,1.09,0,0,1-.15.54l-2.15-.08a1.2,1.2,0,0,1,1.1-1.65A1.19,1.19,0,0,1,286.08,232.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.29,113.93l1.18.68.54.31a1.09,1.09,0,0,1-.54.14A1.18,1.18,0,0,1,287.29,113.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,289.67,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,289.67,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,289.67,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,289.67,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,289.67,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,289.67,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,289.67,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,157a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,207.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,185.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,268.12,185.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,196.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,221.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,207.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,268.12,207.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,135.42a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,268.12,135.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,182.11a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,271.71,182.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,103.09a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,264.53,103.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,142.6a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,192.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,275.3,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,174.93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,271.71,174.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,171.34a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,268.12,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.47,232.14l-2.27-.08a1.18,1.18,0,0,1,1.13-.85A1.17,1.17,0,0,1,264.47,232.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,200.07a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,113.87a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,268.12,113.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,218a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.42,103.57l1.2.7-.11,0A1.19,1.19,0,0,1,269.42,103.57Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,157a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,167.75a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,271.71,167.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,214.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,275.3,214.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,110.28a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,271.71,110.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,228.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,275.3,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,200.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,275.3,200.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,232.4h0l-2.38-.09a1.19,1.19,0,0,1,2.38.08Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,164.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,268.12,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,171.34a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,275.3,171.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,157a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,275.3,157Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,192.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,268.12,192.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,228.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,268.12,228.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,146.2a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,271.71,146.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,131.83a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,271.71,131.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,221.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,268.12,221.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,214.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,121.05a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,185.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,124.64a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,178.52a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,275.3,178.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.91,106.68a1.18,1.18,0,0,1,.39-.87l.81.47.69.4.45.27a1.18,1.18,0,0,1-1.14.93A1.2,1.2,0,0,1,272.91,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,203.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,271.71,203.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,160.56a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,153.38a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,271.71,153.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,225.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,271.71,225.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,189.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,271.71,189.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,178.52a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,210.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,271.71,210.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,106.68a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,268.12,106.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,117.46a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,271.71,117.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,128.24a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,268.12,128.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,139a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,164.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,275.3,164.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,149.79a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,268.12,149.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.34,122a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,469.34,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.23,115.55l.92-.21,1.14-.27a1.16,1.16,0,0,1-2.06.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.75,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,465.75,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.29,117.67a1.12,1.12,0,0,1,.28.73s0,0,0,.06l-1-.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.94,118.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,472.94,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.94,125.59a1.21,1.21,0,0,1-.74,1.1l-1.63-1a.45.45,0,0,1,0-.11,1.2,1.2,0,0,1,2.4,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.53,129.18s0,.07,0,.1l-.18-.1-1-.61-.63-.38a1.13,1.13,0,0,1,.63-.21A1.2,1.2,0,0,1,476.53,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.53,122a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.53,114.81a1.2,1.2,0,1,1-2.39,0,1.18,1.18,0,0,1,.63-1l.56-.13.06,0A1.2,1.2,0,0,1,476.53,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.12,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,480.12,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.12,118.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.71,129.18a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.71,122a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,483.71,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.71,114.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,483.71,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.3,132.77a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,487.3,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.3,125.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,487.3,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.3,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,487.3,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.22,110.83a1,1,0,0,1,.08.39,1.18,1.18,0,0,1-2.36.15Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.9,136.36a1.2,1.2,0,0,1-.8,1.12l-.4-.24-1.16-.7a1.16,1.16,0,0,1,0-.18,1.2,1.2,0,1,1,2.4,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.9,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,490.9,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.9,122a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,490.9,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.7,
    cy: 114.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.49,132.77a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,494.49,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.49,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,494.49,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.49,118.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.49,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,494.49,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.49,140c0,.06,0,.1,0,.16L492.61,139a1.23,1.23,0,0,1,.68-.23A1.19,1.19,0,0,1,494.49,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,226.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,645.35,226.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,219a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,645.35,219Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,211.79a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,645.35,211.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,204.61a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,645.35,204.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,197.42a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,190.24a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,645.35,190.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,183.06a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,645.35,183.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,175.87a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,168.69a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,645.35,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,161.5a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,154.32a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,645.35,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,645.35,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,140a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,132.77a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,645.35,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,645.35,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,118.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,645.35,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,104a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,96.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,645.35,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,89.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,645.35,89.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,82.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,75.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,645.35,75.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.74,72.9l-.09,0,.09,0,.6-.14A1.11,1.11,0,0,1,647.74,72.9Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,229.75a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,648.94,229.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,222.57a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,648.94,222.57Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,215.38a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,208.2a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,648.94,208.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,201a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,648.94,201Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,193.83a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,186.65a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,648.94,186.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,179.46a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,172.28a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,648.94,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,165.1a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,648.94,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,157.91a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,648.94,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,648.94,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,136.36a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,648.94,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,648.94,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,122a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,114.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,648.94,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,648.94,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,100.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,93.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,648.94,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,86.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,648.94,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.94,78.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,648.94,78.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,233.34a1.19,1.19,0,0,1-1.19,1.2,1.18,1.18,0,0,1-.43-.09l-.27-.16a1.19,1.19,0,1,1,1.89-.95Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,226.16a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,226.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,219a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,652.53,219Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,211.79a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,211.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,204.61a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,204.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,197.42a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,652.53,197.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,190.24a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,190.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,183.06a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,183.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,175.87a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,652.53,175.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,168.69a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,161.5a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,652.53,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,154.32a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,147.14a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,140a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,652.53,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,132.77a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,125.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,652.53,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,111.22a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,104a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,652.53,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,96.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,89.67a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,89.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,82.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,652.53,82.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.53,75.3a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,652.53,75.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,222.57a1.19,1.19,0,0,1-1.19,1.19.88.88,0,0,1-.29-.06l-.61-.36a1.17,1.17,0,0,1-.3-.77,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,215.38a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,634.57,215.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,208.2a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,208.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,201a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,201Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,193.83a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,634.57,193.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,186.65a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,186.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,179.46a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,634.57,179.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,172.28a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,165.1a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,157.91a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,634.57,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,150.73a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,143.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,634.57,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,136.36a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,129.18a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,122a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,634.57,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,114.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,107.63a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,100.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,634.57,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,93.26a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,86.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,634.57,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57,78.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,634.57,78.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,219a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,638.16,219Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,211.79a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,638.16,211.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,204.61a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,197.42a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,638.16,197.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,190.24A1.2,1.2,0,1,1,637,189,1.19,1.19,0,0,1,638.16,190.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,183.06a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,175.87a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,638.16,175.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,168.69a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,161.5a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,638.16,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,154.32a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,638.16,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,147.14a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,140a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,638.16,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,132.77a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,638.16,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,125.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,638.16,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,638.16,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,111.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,104a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,638.16,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,96.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,638.16,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,89.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,82.48A1.2,1.2,0,1,1,637,81.29,1.19,1.19,0,0,1,638.16,82.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.16,226.16a1.22,1.22,0,0,1-.13.53l-2-1.22a1.16,1.16,0,0,1,1-.51A1.19,1.19,0,0,1,638.16,226.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.13,75.13a1,1,0,0,1,0,.17A1.19,1.19,0,0,1,637,76.49a1.17,1.17,0,0,1-1.12-.82Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,222.57a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,641.76,222.57Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,215.38a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,641.76,215.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640.56,
    cy: 208.2,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,201a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,641.76,201Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,193.83a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,641.76,193.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,186.65a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,641.76,186.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,179.46a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,641.76,179.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640.56,
    cy: 172.28,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,165.1a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,641.76,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,157.91a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,641.76,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,641.76,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,641.76,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640.56,
    cy: 136.36,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,641.76,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,122a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,641.76,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640.56,
    cy: 114.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,641.76,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,100.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,641.76,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,93.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,641.76,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.76,86.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,641.76,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640.56,
    cy: 78.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,186.65a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,179.46a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,620.2,179.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,172.28a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,620.2,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,165.1a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,157.91a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,620.2,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,150.73a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,143.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,620.2,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,136.36a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,620.2,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,129.18a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,122A1.2,1.2,0,1,1,619,120.8,1.19,1.19,0,0,1,620.2,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,114.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,620.2,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,107.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,100.44A1.2,1.2,0,1,1,619,99.25,1.19,1.19,0,0,1,620.2,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,93.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,86.07A1.2,1.2,0,1,1,619,84.88,1.19,1.19,0,0,1,620.2,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.6,
    cy: 211.79,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,204.61a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,623.8,204.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,197.42a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,623.8,197.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.6,
    cy: 190.24,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,183.06a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,623.8,183.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,175.87a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,623.8,175.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,168.69a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,623.8,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,161.5a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,623.8,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.6,
    cy: 154.32,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,623.8,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,140a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,623.8,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.6,
    cy: 132.77,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,623.8,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,118.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,623.8,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,623.8,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,104a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,623.8,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.6,
    cy: 96.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,89.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,623.8,89.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.8,82.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,623.8,82.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,215.38a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,208.2a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,627.39,208.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,201a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,627.39,201Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,193.83a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,186.65a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,627.39,186.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,179.46a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,172.28a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,627.39,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,165.1a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,627.39,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,157.91a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,627.39,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,627.39,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,136.36a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,627.39,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,627.39,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,122a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,114.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,627.39,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,627.39,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,100.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,93.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,627.39,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,86.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,627.39,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,78.89a1.2,1.2,0,1,1-2.39,0,1.13,1.13,0,0,1,.26-.71l.93-.22.53-.13A1.19,1.19,0,0,1,627.39,78.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,219a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,631,219Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,211.79a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,631,211.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,204.61a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,631,204.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,197.42a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,190.24a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,631,190.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,183.06a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,631,183.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,175.87a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,168.69a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,631,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,161.5a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,154.32a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,631,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,631,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,140a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,132.77a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,631,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,631,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,118.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,631,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,104a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,96.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,631,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,89.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,631,89.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,82.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,605.84,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,122a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,605.84,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.64,
    cy: 114.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,605.84,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,100.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,605.84,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,93.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,605.84,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,86.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,605.84,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,204.61a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,609.43,204.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,197.42a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,190.24a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,609.43,190.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,183.06a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,609.43,183.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,175.87a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,168.69a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,609.43,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,161.5a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,154.32a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,609.43,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,609.43,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,140a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,132.77a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,609.43,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,609.43,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,118.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,609.43,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,104a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,96.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,609.43,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43,89.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,609.43,89.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.29,82a1.23,1.23,0,0,1,.14.53,1.2,1.2,0,0,1-1.2,1.2A1.19,1.19,0,0,1,607,82.49Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,208.2a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,613,208.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,201a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,613,201Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,193.83a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,186.65a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,613,186.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,179.46a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,172.28a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,613,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,165.1a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,613,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,157.91a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,613,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,613,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,136.36a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,613,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,613,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,122a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,114.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,613,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,613,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,100.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,93.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,613,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,86.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,613,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,211.79a1.19,1.19,0,0,1-1.19,1.2c-.06,0-.11,0-.16,0l-.8-.49a1.14,1.14,0,0,1-.24-.68,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,204.61a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,197.42a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,616.61,197.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,190.24a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,616.61,190.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,183.06a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,175.87a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,616.61,175.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,168.69a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,161.5a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,616.61,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,154.32a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,616.61,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,147.14a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,140a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,616.61,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,132.77a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,616.61,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,125.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,616.61,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,616.61,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,111.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,104a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,616.61,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,96.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,616.61,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,89.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.61,82.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,616.61,82.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619,80.09a1.22,1.22,0,0,1-.72-.26l.72-.17,1.07-.26A1.2,1.2,0,0,1,619,80.09Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,215.38a1.3,1.3,0,0,1-.1.49l-.81-.49-.28-.16-.93-.56a1.18,1.18,0,0,1,2.12.72Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,208.2A1.2,1.2,0,1,1,619,207,1.19,1.19,0,0,1,620.2,208.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,201a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,620.2,201Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.2,193.83a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,620.2,193.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,591.47,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,136.36a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,591.47,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,591.47,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,122a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,114.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,591.47,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,591.47,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,100.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,93.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,591.47,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,197.42a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,595.06,197.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,190.24a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,595.06,190.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,183.06a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,595.06,183.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,175.87a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,595.06,175.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,168.69a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,595.06,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,161.5a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,595.06,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,154.32a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,595.06,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,595.06,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,140a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,595.06,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,132.77a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,595.06,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,595.06,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,118.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,595.06,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,595.06,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,104a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,595.06,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,96.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,595.06,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.06,89.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,595.06,89.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,201a1.19,1.19,0,0,1-1.19,1.19h0l-1-.61a1.17,1.17,0,0,1-.18-.58,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,193.83a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,598.65,193.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,186.65a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,179.46a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,598.65,179.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,172.28a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,598.65,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,165.1a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,157.91a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,598.65,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,150.73a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,143.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,598.65,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,136.36a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,598.65,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,129.18a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,122a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,598.65,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,114.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,598.65,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,107.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,100.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,598.65,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,93.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.65,86.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,598.65,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,197.42a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,602.24,197.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,190.24a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,602.24,190.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,183.06a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,175.87a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,602.24,175.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,168.69a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,161.5a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,602.24,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,154.32a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,602.24,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,147.14a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,140a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,602.24,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,132.77a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,602.24,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,125.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,602.24,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,602.24,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,111.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,104a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,602.24,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,96.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,602.24,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,89.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.24,204.61a1.12,1.12,0,0,1-.09.44l-2-1.21a1.16,1.16,0,0,1,.9-.43A1.19,1.19,0,0,1,602.24,204.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,201a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,605.84,201Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,193.83a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,605.84,193.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,186.65a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,605.84,186.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,179.46a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,605.84,179.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.64,
    cy: 172.28,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,165.1a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,605.84,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,157.91a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,605.84,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,605.84,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,605.84,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.64,
    cy: 136.36,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,186.65a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,577.1,186.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,179.46a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,577.1,179.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,172.28a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,577.1,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,165.1a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,577.1,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,157.91a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,577.1,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,150.73a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,577.1,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,143.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,577.1,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,136.36a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,577.1,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,129.18a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,577.1,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,122a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,577.1,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,114.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,577.1,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,107.63a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,577.1,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,100.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,577.1,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.1,93.26a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,577.1,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,183.06a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,175.87a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,580.69,175.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,168.69a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,161.5a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,580.69,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,154.32a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,580.69,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,147.14a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,140a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,580.69,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,132.77a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,580.69,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,125.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,580.69,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,580.69,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,111.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,104a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,580.69,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,96.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,580.69,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,190.24a1.18,1.18,0,0,1-1.13,1.18l-1.14-.68a1.23,1.23,0,0,1-.12-.5,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.32,88.81a1.16,1.16,0,0,1,.37.86,1.2,1.2,0,0,1-2.39,0,1.24,1.24,0,0,1,.08-.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,193.83a1.35,1.35,0,0,1-.08.4l-.66-.4-.46-.28-.88-.52a1.2,1.2,0,0,1,2.08.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,186.65a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,584.29,186.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,179.46a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,584.29,179.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.09,
    cy: 172.28,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,165.1a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,584.29,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,157.91a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,584.29,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,584.29,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,584.29,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.09,
    cy: 136.36,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,584.29,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,122a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,584.29,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.09,
    cy: 114.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,584.29,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,100.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,584.29,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.29,93.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,584.29,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.68,
    cy: 190.24,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,183.06a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,587.88,183.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,175.87a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,587.88,175.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,168.69a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,587.88,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,161.5a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,587.88,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.68,
    cy: 154.32,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,587.88,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,140a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,587.88,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.68,
    cy: 132.77,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,587.88,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,118.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,587.88,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,587.88,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,104a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,587.88,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.68,
    cy: 96.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,89.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,587.88,89.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.27,86.69l1-.24,1.18-.28a1.17,1.17,0,0,1-2.18.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,193.83a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,186.65a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,591.47,186.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,179.46a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,172.28a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,591.47,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,165.1a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,591.47,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,157.91a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.47,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,591.47,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,114.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,555.55,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,555.55,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,100.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,175.87a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,559.14,175.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,168.69a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,161.5a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,559.14,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,154.32a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,559.14,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,147.14a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,140a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,559.14,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,132.77a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,559.14,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,125.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,559.14,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,559.14,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,111.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,104a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,559.14,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.14,96.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,559.14,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,179.46a1.17,1.17,0,0,1-1.07,1.17l-.12-.07-1.11-.67a1.22,1.22,0,0,1-.09-.43,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,172.28a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,562.73,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,165.1a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,157.91a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,562.73,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,150.73a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,143.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,562.73,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,136.36a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,562.73,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,129.18a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,122a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,562.73,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,114.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,562.73,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,107.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.73,100.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,562.73,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.68,93a1.26,1.26,0,0,1,.05.28,1.18,1.18,0,0,1-2.34.26l1.11-.26h0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.33,175.87a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,566.33,175.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.33,168.69a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,566.33,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.33,161.5a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,566.33,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 565.13,
    cy: 154.32,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.33,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,566.33,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.33,140a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,566.33,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 565.13,
    cy: 132.77,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.33,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,566.33,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.33,118.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,566.33,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.33,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,566.33,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.33,104a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,566.33,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 565.13,
    cy: 96.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.33,183.06a1.28,1.28,0,0,1-.07.34l-2-1.19a1.24,1.24,0,0,1,.85-.35A1.2,1.2,0,0,1,566.33,183.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,179.46a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,172.28a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,569.92,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,165.1a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,569.92,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,157.91a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,569.92,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,569.92,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,136.36a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,569.92,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,569.92,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,122a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,114.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,569.92,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,569.92,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,100.44a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.92,93.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,569.92,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,183.06a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,573.51,183.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,175.87a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,168.69a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,573.51,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,161.5a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,154.32a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,573.51,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,573.51,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,140a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,132.77a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,573.51,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,573.51,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,118.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,573.51,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,104a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.51,96.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,573.51,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.31,90.86a1.16,1.16,0,0,1-.37-.07l1.23-.29A1.21,1.21,0,0,1,572.31,90.86Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,157.91a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,534,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,534,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,136.36a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,534,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,534,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,122a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,114.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,534,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,534,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.79,99.81a1.19,1.19,0,0,1,.21.63,1.2,1.2,0,1,1-2.39,0s0-.08,0-.12l1.17-.27Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.59,161.5a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.59,154.32a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,537.59,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.59,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,537.59,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.59,140a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.59,132.77a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,537.59,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.59,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,537.59,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.59,118.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.59,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,537.59,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.59,104a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.18,165.1a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.18,157.91a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,541.18,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.18,150.73a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.18,143.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,541.18,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.18,136.36a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,541.18,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.18,129.18a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.18,122A1.2,1.2,0,1,1,540,120.8,1.19,1.19,0,0,1,541.18,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.18,114.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,541.18,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.18,107.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.18,100.44A1.2,1.2,0,1,1,540,99.25,1.19,1.19,0,0,1,541.18,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,161.5a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,544.77,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,154.32a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,544.77,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,147.14a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,140a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,544.77,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,132.77a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,544.77,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,125.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,544.77,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,544.77,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,111.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,104a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,544.77,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,168.69a1.18,1.18,0,0,1-1,1.16l-1.31-.8a1.05,1.05,0,0,1-.08-.36,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.58,98.05a1.24,1.24,0,0,1-.85-.35l2-.47A1.2,1.2,0,0,1,543.58,98.05Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.37,172.28a1.45,1.45,0,0,1-.06.3l-.5-.3-.64-.39-.81-.48a1.19,1.19,0,0,1,2,.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.37,165.1a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,548.37,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.37,157.91a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,548.37,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.37,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,548.37,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.37,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,548.37,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.17,
    cy: 136.36,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.37,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,548.37,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.37,122a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,548.37,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.17,
    cy: 114.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.37,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,548.37,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.37,100.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,548.37,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,168.69a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,552,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,161.5a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,154.32a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,552,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,552,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,140a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,132.77a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,552,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,552,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,118.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,552,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,104a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,96.85a1.2,1.2,0,1,1-2-.86l1.16-.27A1.19,1.19,0,0,1,552,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,172.28a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,555.55,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,165.1a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,555.55,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,157.91a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,555.55,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,555.55,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,136.36a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,555.55,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,555.55,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.55,122a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.08,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,498.08,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.08,122a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.08,114.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,498.08,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.67,140a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,501.67,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.67,132.77a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,501.67,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.67,125.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,501.67,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.67,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,501.67,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.67,111.22a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,501.67,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.26,143.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,505.26,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.26,136.36a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,505.26,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.26,129.18a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.26,122a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,505.26,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.26,114.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,505.26,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.26,107.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,0,1,.14-.54l1.06-.25.69-.16A1.17,1.17,0,0,1,505.26,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.86,140a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,508.86,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.66,
    cy: 132.77,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.86,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,508.86,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.86,118.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,508.86,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.86,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,508.86,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.86,147.14a1.2,1.2,0,0,1-.87,1.13l-1.48-.89a1,1,0,0,1-.05-.24,1.2,1.2,0,0,1,2.4,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.45,150.73a1.42,1.42,0,0,1,0,.2l-.34-.2-.82-.5-.72-.43a1.14,1.14,0,0,1,.72-.27A1.2,1.2,0,0,1,512.45,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.45,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,512.45,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.25,
    cy: 136.36,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.45,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,512.45,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.45,122a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,512.45,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.25,
    cy: 114.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.45,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,512.45,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,516,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,140a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,132.77a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,516,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,516,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,118.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,516,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,104v0a1.19,1.19,0,0,1-2.27.52Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.63,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,519.63,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.63,143.54a1.2,1.2,0,1,1-1.2-1.19A1.19,1.19,0,0,1,519.63,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.63,136.36a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,519.63,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.63,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,519.63,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.63,122a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,519.63,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.63,114.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,519.63,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.63,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,519.63,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.22,154.32a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,523.22,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.22,147.14a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.22,140a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,523.22,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.22,132.77a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,523.22,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.22,125.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,523.22,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.22,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,523.22,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.22,111.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.22,104a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,523.22,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.81,157.91a1.19,1.19,0,0,1-.93,1.15l-.26-.16-1.14-.69a1.33,1.33,0,0,1-.06-.3,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.81,150.73a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.81,143.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,526.81,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.81,136.36a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,526.81,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.81,129.18a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.81,122a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,526.81,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.81,114.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,526.81,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.81,107.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 529.21,
    cy: 154.32,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.41,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,530.41,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.41,140a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,530.41,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 529.21,
    cy: 132.77,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.41,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,530.41,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.41,118.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,530.41,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.41,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,530.41,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.41,104a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,530.41,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.41,161.5a2.38,2.38,0,0,1,0,.26l-1.91-1.16a1.18,1.18,0,0,1,2,.9Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.88,108.82a1.16,1.16,0,0,1-.55-.15l.55-.13.95-.22A1.18,1.18,0,0,1,496.88,108.82Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.08,136.36a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,498.08,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,236.93a1.11,1.11,0,0,1-.16.57l-.94-.57-.09-.05-1-.59a1.15,1.15,0,0,1,1-.55A1.19,1.19,0,0,1,656.12,236.93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,229.75a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,656.12,229.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,222.57a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,215.38a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,656.12,215.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,208.2a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,656.12,208.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,201a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,656.12,201Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,193.83a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,656.12,193.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,186.65a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,179.46a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,656.12,179.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,172.28a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,656.12,172.28Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,165.1a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,157.91a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,656.12,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,150.73a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,143.54a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,656.12,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,136.36a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,656.12,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,129.18a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,122a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,656.12,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,114.81a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,656.12,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,107.63a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,100.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,656.12,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,93.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,86.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,656.12,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.12,78.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,656.12,78.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.83,71a1.14,1.14,0,0,1,.29.76,1.2,1.2,0,0,1-2.39,0,.88.88,0,0,1,.06-.28l1.14-.27Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,233.34a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,659.72,233.34Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,226.16a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,659.72,226.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,219a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,659.72,219Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658.52,
    cy: 211.79,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,204.61a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,659.72,204.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,197.42a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,659.72,197.42Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658.52,
    cy: 190.24,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,183.06a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,659.72,183.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,175.87a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,659.72,175.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,168.69a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,659.72,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,161.5a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,659.72,161.5Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658.52,
    cy: 154.32,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,659.72,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,140a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,659.72,140Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658.52,
    cy: 132.77,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,659.72,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,118.4a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,659.72,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,659.72,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,104a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,659.72,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658.52,
    cy: 96.85,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,89.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,659.72,89.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,82.48a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,659.72,82.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,75.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,659.72,75.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.91,229.75a1.15,1.15,0,0,1,.25-.68l-.09.68-.06.46A1.19,1.19,0,0,1,660.91,229.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.11,221.37h0l0,.32-.11.87-.15,1.14a1.19,1.19,0,0,1-.94-1.14A1.2,1.2,0,0,1,662.11,221.37Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663,214.64l-.1.74-.12,1a1.15,1.15,0,0,1-.7.25,1.2,1.2,0,1,1,0-2.39A1.18,1.18,0,0,1,663,214.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 662.11,
    cy: 208.2,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,201a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,663.31,201Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,193.83a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,663.31,193.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,186.65a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,663.31,186.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,179.46a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,663.31,179.46Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 662.11,
    cy: 172.28,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,183.06a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,666.9,183.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,93.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,663.31,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,122a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,663.31,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,663.31,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 662.11,
    cy: 114.81,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,157.91a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,663.31,157.91Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,663.31,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,86.07a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,663.31,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.41,196.29l-.28,2.16a1.16,1.16,0,0,1,.28-2.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,143.54a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,663.31,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,161.5a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,71.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,663.31,71.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,663.31,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,165.1a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,663.31,165.1Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 662.11,
    cy: 136.36,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,168.69a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,666.9,168.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.31,100.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,663.31,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,175.87a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 662.11,
    cy: 78.89,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,154.32a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,666.9,154.32Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,147.14a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,666.9,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,140a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,132.77a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,666.9,132.77Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,125.59a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,666.9,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,118.4a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,111.22a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,666.9,111.22Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,104a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,96.85a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,666.9,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,89.67a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,666.9,89.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,82.48a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,75.3a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,666.9,75.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.7,189a1.2,1.2,0,0,1,.62.2l-.28,2.13a1.28,1.28,0,0,1-.34.07,1.2,1.2,0,0,1,0-2.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.77,68.83l2.08-.49a1.18,1.18,0,0,1-1.15,1A1.16,1.16,0,0,1,664.77,68.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.65,171.3l-.13,1-.1.8a1.15,1.15,0,0,1-.32-.8A1.16,1.16,0,0,1,668.65,171.3Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.29,163.9a1.07,1.07,0,0,1,.31.06l-.15,1.14-.15,1.19h0a1.2,1.2,0,0,1,0-2.39Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.42,157.59l0,.32-.08.6a1.17,1.17,0,0,1-1,.6,1.2,1.2,0,0,1,0-2.39A1.17,1.17,0,0,1,670.42,157.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,150.73a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,670.49,150.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,143.54a1.2,1.2,0,1,1-1.2-1.19A1.19,1.19,0,0,1,670.49,143.54Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,136.36a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,670.49,136.36Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,129.18a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,670.49,129.18Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,122a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,670.49,122Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,114.81a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,670.49,114.81Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,107.63a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,670.49,107.63Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,100.44a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,670.49,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,93.26a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,670.49,93.26Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,86.07a1.2,1.2,0,1,1-1.2-1.19A1.19,1.19,0,0,1,670.49,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,78.89a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,670.49,78.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,71.71a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,670.49,71.71Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.69,147.14a1.22,1.22,0,0,1,.16-.57l-.11.84A1.28,1.28,0,0,1,671.69,147.14Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.87,138.76l-.31,2.32a1.17,1.17,0,0,1-.87-1.13A1.2,1.2,0,0,1,672.87,138.76Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.08,125.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,674.08,125.59Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.08,118.4a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,674.08,118.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.08,111.22a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.08,104a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,674.08,104Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.08,96.85a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,674.08,96.85Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.08,89.67a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.08,82.48a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,674.08,82.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.08,75.3a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.08,68.11A1.2,1.2,0,1,1,672.4,67l.33-.08a.9.9,0,0,1,.16,0A1.19,1.19,0,0,1,674.08,68.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.89,131.57a1.19,1.19,0,0,1,.86.38l-.24,1.81a1.13,1.13,0,0,1-.62.21,1.2,1.2,0,1,1,0-2.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.12,113.69l-.15,1.12-.13,1a1.16,1.16,0,0,1,.28-2.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.48,106.43a1.21,1.21,0,0,1,.56.16l-.14,1-.14,1.14a1.37,1.37,0,0,1-.28,0,1.2,1.2,0,1,1,0-2.39Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.67,100.44a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,677.67,100.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.67,93.26a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.67,86.07a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,677.67,86.07Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.67,78.89a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,677.67,78.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.67,71.71a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.35,88.73l-.21,1.66a1.19,1.19,0,0,1-.27-.72A1.2,1.2,0,0,1,679.35,88.73Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.87,68.11a1.2,1.2,0,1,1,1.2,1.2A1.19,1.19,0,0,1,678.87,68.11Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.07,81.29a.93.93,0,0,1,.24,0l-.3,2.33a1.19,1.19,0,0,1,.06-2.38Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.16,74.81,681,76a1.17,1.17,0,0,1-.93.47,1.2,1.2,0,1,1,1.09-1.68Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.28,96.61a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,378.28,96.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.28,103.8a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,378.28,103.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.28,111a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.57,70.69a1.2,1.2,0,1,1-1.78,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.06,121.76a1.2,1.2,0,0,1-1.2,1.19.58.58,0,0,1-.18,0l-.93-.75a1.1,1.1,0,0,1-.08-.4,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.28,82.24a1.2,1.2,0,1,1-1.19-1.18A1.19,1.19,0,0,1,378.28,82.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.28,89.44a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.68,
    cy: 78.65,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.88,107.4a1.2,1.2,0,1,1-1.2-1.21A1.19,1.19,0,0,1,381.88,107.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.88,100.2a1.2,1.2,0,1,1-1.2-1.18A1.2,1.2,0,0,1,381.88,100.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.68,
    cy: 114.57,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.28,75.06a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.88,93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,381.88,93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.06,93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,389.06,93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.06,85.84a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.47,118.16a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,385.47,118.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.47,75.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,385.47,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.88,85.84a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,381.88,85.84Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.47,82.24a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.47,96.61a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,385.47,96.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.47,111a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,385.47,111Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.47,89.44a1.2,1.2,0,1,1-1.2-1.21A1.21,1.21,0,0,1,385.47,89.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.06,107.4a1.2,1.2,0,1,1-1.2-1.21A1.19,1.19,0,0,1,389.06,107.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.06,100.2a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.06,114.57a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.47,103.8a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,385.47,103.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.06,78.65a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,389.06,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.73,70.66a1.18,1.18,0,0,1-.87,2,1.18,1.18,0,0,1-1.19-1.18,1.2,1.2,0,0,1,.32-.82Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.69,93a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.69,78.65a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,374.69,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.69,85.84a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,374.69,85.84Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.4,70.72a1.16,1.16,0,0,1,.29.76,1.2,1.2,0,1,1-2.11-.75Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.69,100.2A1.2,1.2,0,1,1,373.5,99,1.19,1.19,0,0,1,374.69,100.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.69,107.4a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.1,75.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,371.1,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.1,82.24a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.77,78.65a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,338.77,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.76,
    cy: 78.65,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.87,74.55l-.77-.62A1.15,1.15,0,0,1,327.87,74.55Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,85.84a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,346,85.84Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.25,70.91a1.25,1.25,0,0,1,.16.57,1.74,1.74,0,0,1-.05.22l-1-.79Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.41,70.89a1.08,1.08,0,0,1,.18.59,1.2,1.2,0,0,1-2.39,0,1.1,1.1,0,0,1,.17-.58Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.58,70.85a1.2,1.2,0,0,1,.19.63,1.2,1.2,0,0,1-2.39,0,1.19,1.19,0,0,1,.19-.62Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.37,82.24a1.2,1.2,0,1,1-1.2-1.18A1.2,1.2,0,0,1,342.37,82.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.18,75.06a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,335.18,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.37,75.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,342.37,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.74,70.82a1.19,1.19,0,1,1-2.18.66,1.14,1.14,0,0,1,.21-.64Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.55,89.44a1.2,1.2,0,1,1-1.2-1.21A1.21,1.21,0,0,1,349.55,89.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.55,82.24a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.55,75.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,349.55,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.14,85.84a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,353.14,85.84Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.14,78.65a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,353.14,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.14,93a1.17,1.17,0,0,1-1,1.16l-1.38-1.12a.06.06,0,0,1,0,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.91,70.81a1.15,1.15,0,0,1,.23.67,1.2,1.2,0,0,1-2.39,0,1.15,1.15,0,0,1,.23-.67Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.73,96.61a1.16,1.16,0,0,1-.45.91l-.74-.59-.38-.32-.67-.54a1.18,1.18,0,0,1,1.05-.66A1.19,1.19,0,0,1,356.73,96.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.73,89.44a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.73,82.24a1.2,1.2,0,1,1-1.19-1.18A1.19,1.19,0,0,1,356.73,82.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.73,75.06a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.32,93a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.32,85.84a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,360.32,85.84Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.32,78.65a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,360.32,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.07,70.77a1.19,1.19,0,1,1-2.14.71,1.13,1.13,0,0,1,.25-.7Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.32,100.2a1.12,1.12,0,0,1-.11.5l-1.78-1.43a1.09,1.09,0,0,1,.7-.25A1.18,1.18,0,0,1,360.32,100.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.89,103.69l-1.17-1-.13-.11.13,0A1.18,1.18,0,0,1,363.89,103.69Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.72,
    cy: 96.61,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.92,89.44a1.2,1.2,0,0,1-2.4,0,1.2,1.2,0,1,1,2.4,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.92,82.24a1.2,1.2,0,1,1-1.2-1.18A1.2,1.2,0,0,1,363.92,82.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.92,75.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,363.92,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.51,100.2a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.51,93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,367.51,93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.51,85.84a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.51,78.65a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,367.51,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.24,70.74a1.19,1.19,0,1,1-2.12.74,1.09,1.09,0,0,1,.26-.72Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.1,103.8a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,371.1,103.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.1,96.61a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,371.1,96.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.1,89.44a1.2,1.2,0,1,1-1.2-1.21A1.21,1.21,0,0,1,371.1,89.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,125.35a1.18,1.18,0,0,1-.66,1.05l-.53-.42-.77-.63-.37-.29a1.17,1.17,0,0,1,1.14-.91A1.19,1.19,0,0,1,392.65,125.35Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,118.16a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,392.65,118.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,111a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,392.65,111Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,103.8a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,392.65,103.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,96.61a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,392.65,96.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,89.44a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,82.24a1.2,1.2,0,1,1-1.19-1.18A1.19,1.19,0,0,1,392.65,82.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.65,75.06a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,392.65,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,121.76a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,396.24,121.76Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,114.57a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,396.24,114.57Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,107.4a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,100.2A1.2,1.2,0,1,1,395.05,99,1.19,1.19,0,0,1,396.24,100.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,93a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,85.84a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,396.24,85.84Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,78.65a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,396.24,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9,70.64a1.19,1.19,0,1,1-2,.84,1.15,1.15,0,0,1,.34-.83Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,128.94a1.22,1.22,0,0,1-.25.71l-1.83-1.5a1.17,1.17,0,0,1,.89-.41A1.19,1.19,0,0,1,396.24,128.94Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.84,125.35a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,399.84,125.35Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.64,
    cy: 118.16,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.84,111a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,399.84,111Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.84,103.8a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,399.84,103.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.64,
    cy: 96.61,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.84,89.44a1.2,1.2,0,0,1-2.4,0,1.2,1.2,0,1,1,2.4,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.84,82.24a1.2,1.2,0,1,1-1.2-1.18A1.2,1.2,0,0,1,399.84,82.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.84,75.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,399.84,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,121.76a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,403.43,121.76Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,114.57a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,107.4a1.2,1.2,0,1,1-1.2-1.21A1.19,1.19,0,0,1,403.43,107.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,100.2a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,403.43,93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,85.84a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,78.65a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,403.43,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.05,70.6a1.19,1.19,0,0,1-.82,2.06A1.18,1.18,0,0,1,401,71.48a1.25,1.25,0,0,1,.36-.87Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,118.16a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,407,118.16Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,111a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,407,111Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,103.8a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,407,103.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,96.61a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,407,96.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,89.44a1.2,1.2,0,1,1-1.2-1.21A1.21,1.21,0,0,1,407,89.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,82.24a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,75.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,407,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.15,120.61l-.81.65A1.16,1.16,0,0,1,409.15,120.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61,114.57a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,410.61,114.57Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61,107.4a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61,100.2A1.2,1.2,0,1,1,409.42,99,1.19,1.19,0,0,1,410.61,100.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61,93a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,410.61,93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61,85.84a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,410.61,85.84Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61,78.65a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,410.61,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.19,70.57a1.23,1.23,0,0,1,.42.91,1.2,1.2,0,0,1-2.39,0,1.16,1.16,0,0,1,.41-.89Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,117a1.13,1.13,0,0,1,.55.15l-.55.44-.76.6-.38.31a1.7,1.7,0,0,1-.06-.31A1.2,1.2,0,0,1,413,117Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.2,111a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.2,103.8a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,414.2,103.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.2,96.61a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,414.2,96.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.2,89.44a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.2,82.24A1.2,1.2,0,1,1,413,81.06,1.19,1.19,0,0,1,414.2,82.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.2,75.06a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.8,107.4a1.2,1.2,0,1,1-1.2-1.21A1.19,1.19,0,0,1,417.8,107.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.8,100.2A1.2,1.2,0,1,1,416.6,99,1.2,1.2,0,0,1,417.8,100.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.8,93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,417.8,93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.8,85.84a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,417.8,85.84Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.6,
    cy: 78.65,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.8,71.48a1.2,1.2,0,1,1-1.95-.92h1.48A1.15,1.15,0,0,1,417.8,71.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.59,113.94l-1.85,1.46a1.16,1.16,0,0,1-.34-.83,1.19,1.19,0,0,1,1.2-1.19A1.18,1.18,0,0,1,417.59,113.94Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.38,110.94l-.05,0-1.14.91-.29.22A1.18,1.18,0,0,1,419,111a1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.39,103.8a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,421.39,103.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.19,
    cy: 96.61,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.39,89.44a1.2,1.2,0,0,1-2.4,0,1.2,1.2,0,1,1,2.4,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.39,82.24a1.2,1.2,0,1,1-1.2-1.18A1.2,1.2,0,0,1,421.39,82.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.39,75.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,421.39,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,107.4a1.2,1.2,0,1,1-1.2-1.21A1.19,1.19,0,0,1,425,107.4Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,100.2a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,425,93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,85.84a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,78.65a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,425,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,71.48a1.2,1.2,0,1,1-1.9-1h1.4A1.2,1.2,0,0,1,425,71.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.57,103.8a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,428.57,103.8Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.57,96.61a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,428.57,96.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.57,89.44a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.57,82.24a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.57,75.06a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,428.57,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.16,100.2A1.2,1.2,0,1,1,431,99,1.19,1.19,0,0,1,432.16,100.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.16,93a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.16,85.84A1.2,1.2,0,1,1,431,84.65,1.19,1.19,0,0,1,432.16,85.84Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.16,78.65a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,432.16,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.16,71.48a1.2,1.2,0,0,1-2.39,0,1.15,1.15,0,0,1,.54-1l1.31,0A1.21,1.21,0,0,1,432.16,71.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.75,96.61a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,435.75,96.61Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.75,89.44a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.75,82.24a1.2,1.2,0,1,1-1.19-1.18A1.19,1.19,0,0,1,435.75,82.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.75,75.06a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.35,93a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,439.35,93Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.35,85.84a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,439.35,85.84Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.15,
    cy: 78.65,
    r: 1.2,
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.35,71.48a1.2,1.2,0,1,1-1.82-1h1.23A1.16,1.16,0,0,1,439.35,71.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.94,89.44a1.2,1.2,0,1,1-1.2-1.21A1.21,1.21,0,0,1,442.94,89.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.94,82.24a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.94,75.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,442.94,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.33,91.82a1,1,0,0,1,.18,0l-1.36,1.08A1.19,1.19,0,0,1,445.33,91.82Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.53,85.84a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.53,78.65a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,446.53,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.53,71.48a1.2,1.2,0,1,1-1.77-1h1.15A1.2,1.2,0,0,1,446.53,71.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.93,88.23a1.12,1.12,0,0,1,.78.32l-.78.61-.34.28-.7.54a1,1,0,0,1-.16-.54A1.21,1.21,0,0,1,448.93,88.23Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.12,82.24a1.2,1.2,0,1,1-1.19-1.18A1.19,1.19,0,0,1,450.12,82.24Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.12,75.06a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.71,78.65a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,453.71,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.71,71.48a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,0,1,.66-1.07h1.07A1.19,1.19,0,0,1,453.71,71.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.63,85.44l-1.75,1.38a1.15,1.15,0,0,1-.56-1,1.19,1.19,0,0,1,1.2-1.19A1.17,1.17,0,0,1,453.63,85.44Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.31,82.24a1.35,1.35,0,0,1-.07.36l-1.06.83h-.07a1.19,1.19,0,1,1,1.2-1.2Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.31,75.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,457.31,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.9,78.65a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,460.9,78.65Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.9,71.48a1.2,1.2,0,0,1-2.39,0,1.16,1.16,0,0,1,.7-1.09h1A1.17,1.17,0,0,1,460.9,71.48Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.49,75.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,464.49,75.06Z",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.08,71.48a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,0,1,.77-1.12h.83A1.2,1.2,0,0,1,468.08,71.48Z",
    style: {
      fill: "#dadada"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.1,
    cy: 439.79,
    rx: 201.78,
    ry: 18.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 533.97,
    cy: 419.5,
    rx: 170.66,
    ry: 17.61,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "39.47 252.06 123.35 251.81 207.23 251.73 375 251.56 542.77 251.72 626.65 251.81 710.53 252.06 626.65 252.3 542.77 252.39 375 252.56 207.23 252.39 123.35 252.3 39.47 252.06",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.52,243.29c-.64.64-8.06.92-10.75.92s-10.12-.28-10.75-.92,8.34-49.93,10.75-49.93S313.15,242.65,312.52,243.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.67,230.73c-1.84.7-8.62,3.46-10.09,4.27v-.93l4.92-2.87a60.11,60.11,0,0,0,5.3-3.15c.08-.06,0-.22-.08-.18a45.12,45.12,0,0,0-5.18,2.87c-1.67,1-3.32,2-5,3q0-3.54,0-7.09a55.14,55.14,0,0,0,7.74-3.93c.08-.05,0-.2-.07-.16a56.25,56.25,0,0,0-7.67,3.78c0-1.23,0-2.46,0-3.69-.07-6.32-.08-12.66-.25-19,1.61-.81,3.27-1.53,4.88-2.35.11,0,0-.23-.08-.19-1.63.64-3.21,1.39-4.81,2.1-.08-3.27-.21-6.53-.41-9.79a.09.09,0,0,0-.17,0c-.22,6.06-.2,12.13-.13,18.19-1.66-1.33-3.44-2.51-5.14-3.8-.06-.05-.13.06-.06.11,1.77,1.35,3.43,2.85,5.21,4.19,0,.35,0,.69,0,1-1.81-.83-3.64-1.59-5.47-2.38-.14-.06-.27.15-.12.22,1.86.89,3.71,1.8,5.6,2.64,0,3,.09,6,.13,9,.07,5.25.19,10.49.3,15.73-3.42-1.72-6.86-3.41-10.32-5a.11.11,0,1,0-.11.19A106.1,106.1,0,0,0,302,238.79c.09,4.35.18,8.71.23,13.07a.21.21,0,0,0,.42,0c-.07-5.56-.07-11.12-.09-16.67A102.43,102.43,0,0,0,312.79,231C313,231,312.84,230.66,312.67,230.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.58,243.29c-.64.64-8,.92-10.75.92s-10.11-.28-10.75-.92,8.35-49.93,10.75-49.93S80.22,242.65,79.58,243.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.73,230.73c-1.83.7-8.62,3.46-10.09,4.27v-.93l4.92-2.87a58.69,58.69,0,0,0,5.3-3.15c.08-.06,0-.22-.07-.18a44.43,44.43,0,0,0-5.19,2.87q-2.5,1.47-5,3l0-7.09a55.57,55.57,0,0,0,7.73-3.93c.09-.05,0-.2-.07-.16a55.57,55.57,0,0,0-7.66,3.78l0-3.69c-.07-6.32-.08-12.66-.24-19,1.61-.81,3.27-1.53,4.87-2.35a.1.1,0,0,0-.08-.19c-1.63.64-3.2,1.39-4.8,2.1-.09-3.27-.22-6.53-.41-9.79a.09.09,0,0,0-.17,0c-.23,6.06-.21,12.13-.13,18.19-1.67-1.33-3.45-2.51-5.15-3.8-.06-.05-.12.06-.06.11,1.77,1.35,3.43,2.85,5.21,4.19,0,.35,0,.69,0,1-1.81-.83-3.65-1.59-5.47-2.38-.15-.06-.27.15-.13.22,1.86.89,3.72,1.8,5.6,2.64q.08,4.52.14,9c.06,5.25.18,10.49.29,15.73-3.41-1.72-6.85-3.41-10.31-5-.13-.07-.25.12-.12.19a107.22,107.22,0,0,0,10.44,5.25c.09,4.35.18,8.71.24,13.07a.21.21,0,0,0,.41,0c-.06-5.56-.07-11.12-.09-16.67A103.6,103.6,0,0,0,79.86,231C80,231,79.91,230.66,79.73,230.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.59,243.29c-.63.64-8.05.92-10.75.92s-10.11-.28-10.75-.92,8.35-49.93,10.75-49.93S692.23,242.65,691.59,243.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.74,230.73c-1.83.7-8.62,3.46-10.08,4.27,0-.31,0-.62,0-.93l4.93-2.87a58.52,58.52,0,0,0,5.29-3.15c.08-.06,0-.22-.07-.18a45.12,45.12,0,0,0-5.18,2.87c-1.67,1-3.32,2-5,3q0-3.54,0-7.09a55.69,55.69,0,0,0,7.74-3.93c.08-.05,0-.2-.07-.16a55.68,55.68,0,0,0-7.67,3.78c0-1.23,0-2.46,0-3.69-.06-6.32-.08-12.66-.24-19,1.61-.81,3.27-1.53,4.88-2.35.1,0,0-.23-.08-.19-1.64.64-3.21,1.39-4.81,2.1-.09-3.27-.21-6.53-.41-9.79a.09.09,0,0,0-.17,0c-.22,6.06-.21,12.13-.13,18.19-1.67-1.33-3.44-2.51-5.14-3.8-.07-.05-.13.06-.07.11,1.78,1.35,3.44,2.85,5.22,4.19,0,.35,0,.69,0,1-1.81-.83-3.64-1.59-5.47-2.38-.14-.06-.27.15-.12.22,1.86.89,3.71,1.8,5.6,2.64,0,3,.09,6,.13,9,.07,5.25.18,10.49.29,15.73-3.41-1.72-6.85-3.41-10.31-5a.11.11,0,1,0-.11.19,107.06,107.06,0,0,0,10.43,5.25c.1,4.35.19,8.71.24,13.07,0,.26.42.26.41,0-.06-5.56-.07-11.12-.08-16.67A102.43,102.43,0,0,0,691.87,231C692,231,691.92,230.66,691.74,230.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.07,244.53c-.54.55-6.91.79-9.22.79s-8.68-.24-9.23-.79,7.17-42.84,9.23-42.84S135.62,244,135.07,244.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.2,233.76c-1.57.6-7.39,3-8.65,3.66,0-.27,0-.53,0-.8l4.23-2.46a51.69,51.69,0,0,0,4.54-2.7c.07-.05,0-.2-.06-.16a38.62,38.62,0,0,0-4.45,2.46c-1.43.84-2.85,1.71-4.26,2.58q0-3,0-6.08a48.18,48.18,0,0,0,6.64-3.38c.07,0,0-.17-.06-.14a49,49,0,0,0-6.58,3.24l0-3.16c-.06-5.43-.07-10.86-.2-16.29,1.38-.69,2.8-1.31,4.18-2a.09.09,0,0,0-.07-.17c-1.4.55-2.75,1.2-4.13,1.8-.07-2.8-.18-5.6-.35-8.39a.07.07,0,1,0-.14,0c-.2,5.2-.18,10.4-.11,15.61-1.43-1.15-3-2.16-4.42-3.27,0,0-.11.06,0,.1,1.52,1.16,2.94,2.44,4.47,3.6,0,.29,0,.58,0,.88-1.55-.71-3.12-1.37-4.69-2-.12,0-.23.12-.11.18,1.6.77,3.19,1.55,4.81,2.27q.06,3.87.11,7.73c.06,4.5.16,9,.26,13.5-2.93-1.48-5.89-2.92-8.85-4.32-.12-.05-.22.11-.1.17a92.41,92.41,0,0,0,9,4.5c.08,3.74.16,7.48.21,11.22a.18.18,0,0,0,.35,0c-.05-4.77-.06-9.54-.07-14.31a88.2,88.2,0,0,0,8.76-3.56C135.45,234,135.35,233.7,135.2,233.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.93,245.72c.46.46,5.81.67,7.76.67s7.31-.21,7.77-.67-6-36.08-7.77-36.08S410.47,245.26,410.93,245.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.82,236.65c1.32.5,6.23,2.5,7.29,3.08v-.67c-1.18-.7-2.37-1.38-3.56-2.08a43.32,43.32,0,0,1-3.83-2.27c-.05,0,0-.16.06-.13a31.71,31.71,0,0,1,3.74,2.07c1.21.71,2.4,1.44,3.59,2.17,0-1.71,0-3.41,0-5.12a41.32,41.32,0,0,1-5.59-2.84c-.06,0,0-.15,0-.12a40.68,40.68,0,0,1,5.54,2.73c0-.89,0-1.78,0-2.66.05-4.57.06-9.15.18-13.72-1.17-.59-2.36-1.11-3.53-1.7-.07,0,0-.17.06-.14,1.18.46,2.32,1,3.48,1.52.06-2.36.15-4.72.29-7.07a.06.06,0,1,1,.12,0c.17,4.38.15,8.76.1,13.14,1.2-1,2.49-1.81,3.71-2.74.05,0,.1,0,.05.08-1.28,1-2.48,2-3.77,3,0,.24,0,.49,0,.74,1.31-.6,2.64-1.15,4-1.72.1,0,.19.1.09.15-1.35.65-2.69,1.31-4.05,1.92,0,2.17-.07,4.34-.1,6.51-.05,3.79-.13,7.58-.21,11.37,2.47-1.25,5-2.47,7.45-3.64.1,0,.18.09.09.14a78.28,78.28,0,0,1-7.55,3.79c-.06,3.15-.13,6.3-.17,9.44a.15.15,0,0,1-.3,0c0-4,.06-8,.07-12a74.52,74.52,0,0,1-7.38-3A.11.11,0,0,1,410.82,236.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.68,244c-.59.59-7.44.85-9.92.85s-9.34-.26-9.93-.85,7.71-46.08,9.93-46.08S256.26,243.38,255.68,244Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.81,232.38c-1.69.64-7.95,3.19-9.3,3.94,0-.29,0-.57,0-.86l4.54-2.65a52.07,52.07,0,0,0,4.89-2.91c.08-.05,0-.2-.07-.16a42,42,0,0,0-4.78,2.64c-1.54.91-3.06,1.84-4.58,2.77,0-2.18,0-4.36,0-6.54a50.94,50.94,0,0,0,7.14-3.63c.08,0,0-.19-.06-.15a54.06,54.06,0,0,0-7.08,3.49c0-1.13,0-2.27,0-3.4-.07-5.84-.08-11.68-.23-17.52,1.49-.75,3-1.41,4.5-2.16.1-.05,0-.22-.07-.18-1.51.59-3,1.28-4.44,1.93-.08-3-.19-6-.38-9,0-.09-.15-.1-.15,0-.21,5.6-.19,11.19-.12,16.79-1.54-1.23-3.18-2.31-4.75-3.51-.06,0-.12.06-.06.11,1.64,1.24,3.17,2.62,4.81,3.86,0,.32,0,.64,0,.95-1.67-.76-3.37-1.47-5.05-2.19-.13-.06-.25.13-.12.19,1.72.83,3.43,1.67,5.17,2.45,0,2.77.09,5.54.12,8.31q.11,7.26.28,14.52c-3.15-1.59-6.33-3.15-9.52-4.65-.12-.06-.23.11-.11.18a97.36,97.36,0,0,0,9.63,4.84q.14,6,.22,12.06c0,.25.39.25.38,0-.05-5.12-.06-10.25-.07-15.38a95.69,95.69,0,0,0,9.42-3.83C256.08,232.58,256,232.31,255.81,232.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.64,244c-.58.59-7.43.85-9.92.85s-9.33-.26-9.92-.85,7.7-46.08,9.92-46.08S559.23,243.38,558.64,244Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.78,232.38c-1.69.64-7.95,3.19-9.31,3.94v-.86l4.54-2.65a52.07,52.07,0,0,0,4.89-2.91c.08-.05,0-.2-.07-.16a42,42,0,0,0-4.78,2.64c-1.54.91-3.06,1.84-4.58,2.77,0-2.18,0-4.36,0-6.54a51.49,51.49,0,0,0,7.14-3.63c.08,0,0-.19-.06-.15a53.45,53.45,0,0,0-7.08,3.49c0-1.13,0-2.27,0-3.4-.06-5.84-.07-11.68-.22-17.52,1.49-.75,3-1.41,4.5-2.16.1-.05,0-.22-.07-.18-1.51.59-3,1.28-4.44,1.93-.08-3-.19-6-.38-9,0-.09-.15-.1-.15,0-.21,5.6-.19,11.19-.12,16.79-1.54-1.23-3.18-2.31-4.75-3.51-.06,0-.12.06-.06.11,1.64,1.24,3.17,2.62,4.81,3.86,0,.32,0,.64,0,.95-1.66-.76-3.36-1.47-5-2.19-.14-.06-.25.13-.12.19,1.72.83,3.43,1.67,5.17,2.45,0,2.77.09,5.54.12,8.31q.11,7.26.28,14.52c-3.15-1.59-6.33-3.15-9.52-4.65-.12-.06-.23.11-.11.18a97.36,97.36,0,0,0,9.63,4.84q.13,6,.22,12.06c0,.25.39.25.38,0,0-5.12-.06-10.25-.08-15.38a94.88,94.88,0,0,0,9.43-3.83C559.05,232.58,558.94,232.31,558.78,232.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.72,246.4c.41.41,5.19.6,6.93.6s6.52-.19,6.93-.6-5.38-32.2-6.93-32.2S223.31,246,223.72,246.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.62,238.3c1.18.45,5.56,2.24,6.51,2.76v-.6L227,238.61c-1.13-.67-2.35-1.26-3.41-2a.06.06,0,0,1,.05-.11,29.46,29.46,0,0,1,3.34,1.85c1.07.63,2.14,1.28,3.2,1.93,0-1.52,0-3,0-4.57a36.5,36.5,0,0,1-5-2.53s0-.14,0-.11a36.66,36.66,0,0,1,5,2.44c0-.79,0-1.59,0-2.38,0-4.08.05-8.16.15-12.24-1-.53-2.1-1-3.14-1.51-.07,0,0-.16,0-.13,1.05.41,2.07.9,3.1,1.35.06-2.1.14-4.21.27-6.31a.05.05,0,1,1,.1,0c.15,3.91.14,7.82.09,11.73,1.07-.85,2.22-1.61,3.31-2.45a0,0,0,0,1,.05.07c-1.15.88-2.22,1.84-3.37,2.71V227c1.16-.53,2.35-1,3.52-1.53.1,0,.18.09.08.13-1.2.58-2.39,1.17-3.61,1.71,0,1.94-.06,3.88-.08,5.81-.05,3.38-.12,6.77-.19,10.15q3.3-1.68,6.65-3.25c.08,0,.16.08.07.13a71.69,71.69,0,0,1-6.73,3.38c-.06,2.81-.12,5.62-.15,8.43a.14.14,0,0,1-.27,0c0-3.58.05-7.17.06-10.75a66.79,66.79,0,0,1-6.59-2.68C223.43,238.44,223.51,238.26,223.62,238.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.1,246.4c.41.41,5.2.6,6.94.6s6.52-.19,6.93-.6-5.38-32.2-6.93-32.2S519.69,246,520.1,246.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520,238.3c1.18.45,5.56,2.24,6.5,2.76,0-.2,0-.4,0-.6l-3.18-1.85a39,39,0,0,1-3.42-2s0-.14.05-.11a28.75,28.75,0,0,1,3.35,1.85c1.07.63,2.14,1.28,3.2,1.93,0-1.52,0-3,0-4.57a36.5,36.5,0,0,1-5-2.53c-.06,0,0-.14,0-.11a36.66,36.66,0,0,1,4.95,2.44c0-.79,0-1.59,0-2.38.05-4.08.06-8.16.16-12.24-1-.53-2.11-1-3.14-1.51-.07,0,0-.16,0-.13,1,.41,2.06.9,3.1,1.35,0-2.1.13-4.21.26-6.31,0-.07.11-.07.11,0,.15,3.91.13,7.82.09,11.73,1.07-.85,2.22-1.61,3.31-2.45,0,0,.09,0,0,.07-1.14.88-2.21,1.84-3.36,2.71,0,.22,0,.44,0,.66,1.17-.53,2.35-1,3.53-1.53.09,0,.18.09.08.13-1.2.58-2.4,1.17-3.61,1.71l-.09,5.81c0,3.38-.12,6.77-.19,10.15q3.3-1.68,6.65-3.25c.09,0,.16.08.08.13a72.93,72.93,0,0,1-6.73,3.38c-.06,2.81-.12,5.62-.16,8.43a.13.13,0,0,1-.26,0c0-3.58,0-7.17,0-10.75a67.62,67.62,0,0,1-6.58-2.68A.11.11,0,0,1,520,238.3Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tent--inject-92"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.5,
    y: 183.6,
    width: 2,
    height: 274.31,
    transform: "translate(-51.71 581.91) rotate(-81.89)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.76,
    y: 172.46,
    width: 2,
    height: 225.65,
    transform: "translate(141.29 732.3) rotate(-82.28)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.58,
    y: 210.08,
    width: 165.34,
    height: 2,
    transform: "translate(3.73 429.69) rotate(-52.74)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.76,
    y: 125.84,
    width: 2,
    height: 205.59,
    transform: "translate(-33.46 353.66) rotate(-35.8)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.66,160.37S341,297.8,397.73,338.47L580.38,297.6S524.66,246,489.9,160.37C489.9,160.37,436.43,186.61,299.66,160.37Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.66,160.37S341,297.8,397.73,338.47L580.38,297.6S524.66,246,489.9,160.37C489.9,160.37,436.43,186.61,299.66,160.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.73,338.47c-27.88-9.52-207-31.49-207-31.49,64.61-30.5,108.89-146.61,108.89-146.61a0,0,0,0,0,0,0C300.31,162.52,341.44,298.11,397.73,338.47Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.73,338.47c-27.88-9.52-207-31.49-207-31.49,64.61-30.5,108.89-146.61,108.89-146.61a0,0,0,0,0,0,0C300.31,162.52,341.44,298.11,397.73,338.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.73,338.47c-22.91-7.82-148-24.06-191.78-29.59-9.5-1.2-15.18-1.9-15.18-1.9,64.61-30.5,108.89-146.61,108.89-146.61a0,0,0,0,0,0,0c.1.35,1.3,4.31,3.49,10.84C314.23,204.5,350.69,304.73,397.73,338.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.74,292.17,402,319.78c-38.18-41.76-70.4-128.43-79.84-155.44,82.43,13.3,130.71,6.49,152.88.9C501.3,233,557.74,292.17,557.74,292.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.41,257.46S402.65,234.17,400,217.12c0,0,39.36-.33,56.41-5.58,0,0,12.46,26.9,18.7,34.44C475.14,246,454.14,255.49,417.41,257.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.17,171.24c-7.87,26.59-39.26,100-97.22,137.64-9.5-1.2-15.18-1.9-15.18-1.9,64.61-30.5,108.89-146.61,108.89-146.61a0,0,0,0,0,0,0C299.78,160.75,301,164.71,303.17,171.24Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.17,171.24c-7.87,26.59-39.26,100-97.22,137.64-9.5-1.2-15.18-1.9-15.18-1.9,64.61-30.5,108.89-146.61,108.89-146.61a0,0,0,0,0,0,0C299.78,160.75,301,164.71,303.17,171.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.2,322.31c-8.06-1.15-16.18-2.29-24.2-3.4,19-44.12,21.17-147.67,21.17-147.67C309.66,240.33,308.2,292.74,306.2,322.31Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.52,
    y: 223.17,
    width: 216.28,
    height: 2,
    transform: "translate(-80.28 286.45) rotate(-52.76)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.62,
    y: 120.31,
    width: 2,
    height: 253.3,
    transform: "translate(-75.69 218.28) rotate(-30.71)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.53,265.93h41.7s-.09-6.21-4.19-7.86a5.6,5.6,0,0,0-6.54,1.57s-1.67-11.41-9.31-11.41-11.3,9.84-11.3,9.84a5.86,5.86,0,0,0-6-2.42C76.7,256.21,76.53,265.93,76.53,265.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3,265.93H87.67s-1-4.28-3-4.59a3,3,0,0,0-3,1.68s.09-6-3.67-7-6.91,4.25-6.91,4.25-2.36-3-5.58-2.81-4,5.16-4,5.16S58.59,260.92,57.3,265.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.25,354.38h64.18s-.15-9.56-6.46-12.09a8.6,8.6,0,0,0-10.06,2.41s-2.57-17.56-14.33-17.56-17.38,15.15-17.38,15.15-2.64-4.58-9.16-3.73S388.25,354.38,388.25,354.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.71,357.87h67.18s-2.21-9.47-6.66-10.14-6.53,3.72-6.53,3.72.2-13.21-8.12-15.46-15.3,9.43-15.3,9.43-5.21-6.66-12.32-6.23-8.91,11.42-8.91,11.42S422.57,346.79,419.71,357.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.7,308.13H647s.1-6.81,4.6-8.62a6.13,6.13,0,0,1,7.17,1.72s1.83-12.52,10.21-12.52,12.4,10.8,12.4,10.8a6.41,6.41,0,0,1,6.53-2.65C692.52,297.47,692.7,308.13,692.7,308.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.05,317.84s-2.48-11.55-7.42-13.33-8,3.4-8,3.4-1.17-11-8.18-14.34S638.23,297,638.23,297s-5.38-14-15-14-14.45,20.49-14.45,20.49-5.67-6.11-11.49-2.66-5.81,17-5.81,17Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trunk--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.88,366.31V415L514,405.47c-4.87-.26-8.82-9.13-8.82-19.82s3.95-19.34,8.82-19.34Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.88,366.31V415L514,405.47c-4.87-.26-8.82-9.13-8.82-19.82s3.95-19.34,8.82-19.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.6,390.39c0,13.3,3.95,24.29,8.83,24.54s8.82-10.52,8.82-24.08-4-24.54-8.82-24.54S684.6,377.09,684.6,390.39Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.6,390.39c0,13.3,3.95,24.29,8.83,24.54s8.82-10.52,8.82-24.08-4-24.54-8.82-24.54S684.6,377.09,684.6,390.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "512.59 370.49 533.41 370.26 554.23 370.14 595.87 370.03 637.5 370.13 658.32 370.26 679.14 370.49 658.32 370.71 637.5 370.84 595.87 370.94 554.23 370.84 533.41 370.71 512.59 370.49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M620,381.94c4.93-.19,9.86-.28,14.79-.35s9.86-.07,14.79-.11,9.86,0,14.79.11l7.4.12c2.46.08,4.93.12,7.39.23-2.46.1-4.93.15-7.39.22l-7.4.13c-4.93.07-9.86.07-14.79.1s-9.86,0-14.79-.1S624.91,382.13,620,381.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M529.64,376.59c6.72-.19,13.44-.28,20.16-.35l20.15-.11,20.16.1,10.08.13,10.08.23-10.08.22-10.08.13L570,377l-20.15-.1C543.08,376.86,536.36,376.78,529.64,376.59Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M525,390.62c7.51,0,15,.13,22.52.25l22.51.49,22.5.71,11.25.42L615,393l-11.26-.08-11.26-.17L570,392.28l-22.5-.71C540,391.3,532.45,391,525,390.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M565.17,402.79c9,.25,18,.6,27,1l27,1.22,27,1.44,13.48.79,13.47.89-13.49-.44-13.5-.54-27-1.22-27-1.44C583.14,404,574.15,403.42,565.17,402.79Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M602.29,398.48c6.47,0,12.93,0,19.39.09l19.38.35,19.38.55,9.68.35c3.23.15,6.46.27,9.69.45-3.24,0-6.47,0-9.7,0l-9.69-.1L641,399.83l-19.38-.56C615.21,399.05,608.75,398.82,602.29,398.48Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M513.94,385.68c5.68-.19,11.36-.28,17-.35s11.36-.07,17-.11,11.36,0,17,.11l8.52.13c2.84.07,5.68.12,8.52.22-2.84.1-5.68.15-8.52.23L565,386c-5.67.08-11.35.07-17,.11s-11.36,0-17-.11S519.62,385.87,513.94,385.68Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M628.24,393a70.58,70.58,0,0,1,16.09,0,70.58,70.58,0,0,1-16.09,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M531,400.56a72,72,0,0,1,16.08,0,60.21,60.21,0,0,1-8,.46A61.93,61.93,0,0,1,531,400.56Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.77,421.11c2.26.86,67.76,2.05,70.32.59.28-.16.21-3.06,1.17-10.53.05-.36,1.54-1.75,3.87-3.7,8.76-7.35,29.35-22.82,29.35-22.82l-32.69-28.4-31.68,31.13-8.24,8.1s-26.76,14.45-29.41,16.36S396.52,420.24,398.77,421.11Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.77,421.1c2.26.88,67.76,2.06,70.32.6.28-.16.2-3.05,1.17-10.54.05-.35,1.54-1.73,3.88-3.7,3-2.55,4.49-3.72,9-7.24L441.6,384.94l-2.49,2.44-8.23,8.1s-26.77,14.45-29.41,16.36S396.52,420.24,398.77,421.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.26,422c2.28.79,72.07,1.55,74.58,0,.59-.37,1.13-4.42,1.56-10,.06-.7,7.13-6.35,8.09-7.39l-42.76-14.41-5.4,5.08S398.85,410,396.28,412,392,421.22,394.26,422Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.23,419.4c11-.14,59.6.33,70.45,1,.09,0,.09.07,0,.07-10.87.38-59.5-.44-70.45-.91C395,419.57,395,419.41,395.23,419.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.84,395.79c4.32-.75,9.59,0,12.85,3.09.13.12-.05.29-.19.25a60.7,60.7,0,0,0-12.65-2.79A.28.28,0,0,1,426.84,395.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.7,397.63c4.33-.75,9.59,0,12.85,3.09.13.12,0,.29-.18.25a60.79,60.79,0,0,0-12.66-2.79A.28.28,0,0,1,423.7,397.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.57,399.47c4.32-.75,9.59,0,12.85,3.09.13.12-.05.29-.19.25A60.7,60.7,0,0,0,420.58,400,.28.28,0,0,1,420.57,399.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.43,401.31c4.33-.75,9.59,0,12.85,3.09.13.12,0,.29-.18.25a60.79,60.79,0,0,0-12.66-2.79A.28.28,0,0,1,417.43,401.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.85,391.89c3,2.41,7,3.43,10.53,4.79a.53.53,0,0,0,.68-.53.13.13,0,0,0,.11-.16,23.09,23.09,0,0,0-6.53-10c-1.78-1.53-4.93-2.62-6.65-.3S419.09,390.49,420.85,391.89Zm-1.06-3.48c-.7-4.74,4.35-2.2,5.62-1a26.83,26.83,0,0,1,2.26,2.5c1.47,1.81,2.66,3.79,3.94,5.73-1.7-.77-3.46-1.39-5.19-2.11C424.37,392.67,420.18,391,419.79,388.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.64,389.59c-1-2.71-4.33-2.53-6.47-1.56a23.17,23.17,0,0,0-9,7.76.11.11,0,0,0,.06.17.53.53,0,0,0,.51.7c3.78-.32,7.87-.19,11.44-1.67C445.23,394.13,447.6,392.14,446.64,389.59Zm-9.3,5.41c-1.86.21-3.72.32-5.57.59a68.89,68.89,0,0,1,5.38-4.41,24.22,24.22,0,0,1,2.86-1.77c1.55-.79,7.11-1.83,5.12,2.53C444,394.34,439.55,394.76,437.34,395Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.66,385.65l40.41,20.93s42.09-38.1,45.95-38.38,60.48,38.14,89,38.26c29.53.12,31-30.81,31-30.81L602,365.75c-31.05-15.3-63.39-42.78-84.54-40.22C494.44,328.31,438.66,385.65,438.66,385.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.53,380.31c6.82,3.37,4.91,2.32,11.7,5.76,3.32,1.68,20,10.11,22.86,12.2.06.05,0,.16-.07.13-3.34-1.12-19.86-9.9-23.15-11.65-6.72-3.57-4.75-2.61-11.43-6.25A.11.11,0,1,1,448.53,380.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.22,396.93c7.9-7,33.79-29.64,34.84-30.48a14.28,14.28,0,0,1,2.69-2,2.85,2.85,0,0,1,2.49.21c1.2.55,2.37,1.17,3.56,1.75l7,3.42c9.05,4.41,18.05,8.95,27.18,13.22,8.77,4.11,15,8,24.19,11.14a138,138,0,0,0,28.11,6.7c1.18.14,2.36.27,3.55.38.08,0,.08.14,0,.13a113.28,113.28,0,0,1-27.66-5.14c-9.07-2.79-15.23-6.42-23.85-10.38-8.94-4.11-17.74-8.51-26.55-12.89-4.65-2.31-9.29-4.64-14-6.93-1.06-.51-2.56-1.64-3.77-1.08a6.34,6.34,0,0,0-1.39,1l-1.55,1.29c-2,1.66-33.73,29-34.77,29.77C486.25,397.1,486.15,397,486.22,396.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.12,375.65S650,403.58,636,414.56s-116.3,9.65-131.83,4.63-16-30.08,1-35.88c16.15-5.52,84.83-8.21,86.53-8.88.42-.17-6.09-4.08-6.07-4.32l15.63-4.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.92,374.94c0-.12.2-.08.2,0a13.86,13.86,0,0,0,3.23,8.88c2.38,2.74,5.88,4.28,9.06,5.89.31.15.08.63-.24.53a27.84,27.84,0,0,1-5.61-2.41,13.76,13.76,0,0,1-4.22-3.51A12,12,0,0,1,623.92,374.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.76,371.48c.71-.91,1.48-1.77,2.22-2.65,1.75-2.08,3.51-4.17,5.34-6.18.18-.19.52.08.36.29-1.24,1.61-2.54,3.18-3.83,4.75-.66.81-1.32,1.61-2,2.41a15.42,15.42,0,0,0-1.85,2.35c-.48.9.15,1.66,1.08,1.76a3.2,3.2,0,0,0,2.23-.82,29.09,29.09,0,0,0,3.79-4.05c.74-.83,1.47-1.66,2.22-2.47s1.64-1.7,2.44-2.57c.05-.06.15,0,.1.09-.69.94-1.33,1.94-2,2.89s-1.39,1.9-2.11,2.83-1.38,1.75-2.1,2.6a8.66,8.66,0,0,1-2.14,1.91c-1.32.78-3.63.95-4.34-.77A2.42,2.42,0,0,1,592.76,371.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.28,419.28c5.34.1,10.68.41,16,.53s10.61.14,15.91.09q16-.15,31.93-1.24c10.74-.74,22.33-1.81,33-3.29,5.1-.71,10.28-1.3,15.32-2.38a24.18,24.18,0,0,0,12.09-6.18c6.91-6.7,9.59-16.55,10.7-26,.15-1.26.27-2.52.37-3.79,0-.09.14-.09.13,0-.62,9.65-2.12,19.72-8.2,27.48a24.19,24.19,0,0,1-9.88,7.68c-4.78,1.91-10.09,2.36-15.13,3-10.71,1.46-22.34,2.58-33.11,3.41s-21.71,1.37-32.58,1.53-21.76,0-32.62-.53c-1.32-.06-2.64-.14-4-.26C506.2,419.4,506.2,419.28,506.28,419.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540,378.22c3.37-.5,6.73-1,10.11-1.33s6.84-.66,10.26-.95c6.77-.58,13.56-1.09,20.35-1.41,3.85-.18,7.71-.2,11.57-.15.12,0,.11.18,0,.19-6.78.61-13.57,1-20.37,1.49s-13.56,1.05-20.33,1.69c-3.84.37-7.68.65-11.52,1C539.76,378.74,539.7,378.26,540,378.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.78,369.77a52.51,52.51,0,0,1,7.79,4.17,63,63,0,0,1,7.21,5.05c.06.05,0,.13-.09.1-2.64-1.22-5.18-2.75-7.7-4.22a72.28,72.28,0,0,1-7.38-4.74C584.45,370,584.55,369.68,584.78,369.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.94,317.72c-15.42,10-36.48,19.42-41.52,19.38-6.36,0-34.2-16.65-35.4-17.59-3-2.35,10.91-25.76,14.18-23.39,5,3.61,21.68,18.18,23.58,18.13s16.89-2,33.05-4.84C616,307.44,620.52,311.54,610.94,317.72Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539,322.35c3,1.14,16.19-17.42,14.75-20.41-.28-.56-2.07-3.69-2.65-5a36.24,36.24,0,0,1-4.47-11.71c-1.13-5.38-2.22-11.91-5.18-11.84-4.3.09-2.81,6.5-3.25,12.48-2.71-1.81-5.22-3.11-6.95-3.33-5.77-.73-14.94,19.43-11.46,24.21C525.67,314.89,533,320.11,539,322.35Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.21,318.56c4.87-4.95,9.92-9.69,15.05-14.34l3.84-3.47.44-.42a3.76,3.76,0,0,1,.69-.53c.43-.26.81-.45,1.2-.66l2.35-1.17c3.14-1.5,6.29-2.93,9.45-4.35s6.35-2.78,9.56-4.12l2.41-1,1.22-.48.62-.23.32-.12.4-.12a10.68,10.68,0,0,1,1.44-.05h1.31l2.6.07c3.47.09,6.93.21,10.39.38s6.92.3,10.38.51c-6.93.17-13.86.28-20.78.37l-2.59.05-1.29,0a11.43,11.43,0,0,0-1.15.06l-.5.2-.58.24-1.18.52L553.45,291q-4.73,2.13-9.42,4.33c-3.14,1.44-6.28,2.9-9.38,4.41l-2.31,1.13c-.37.19-.76.39-1.08.58s-.07,0-.34.25l-.51.46c-1.31,1.16-2.61,2.3-3.94,3.41C521.19,310.09,515.79,314.43,510.21,318.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.38,284.17c.94-.77,4.91.4,6.11.31s4.86-.28,6.28.26,1.77,6.77.51,8.36-5.61.16-7.1.15-4.74,1-5.95-.3S563.65,285.59,565.38,284.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.73,294c-.58,3-3.74.58-3.74.58s3.71,4.53,1.93,7.35-5.44-.3-5.71-.51c.2.24,3.5,4.49,1.42,7.14s-5.38-.92-5.58-1.16c.11.29,1.52,4.09-.52,5.74-3.51,2.84-7.4-6.78-10.82-8.06a23.7,23.7,0,0,1-.38,2.44s-5-7.28-4.48-10.34c.45-2.56,3.48-1.87,3.48-1.87s-1.58-2.79,0-4.93c.82-1.09,3.29-.77,3.29-.77a4,4,0,0,1,.35-4.1c1.21-1.45,3.5-.9,3.5-.9s-.1-2.71,1.62-3.79C531.53,278.62,545,287.65,543.73,294Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.84,284.63c-.05,0,0-.09,0-.08a28.1,28.1,0,0,1,13.3,10.13c.1.15-.1.38-.24.24A57.47,57.47,0,0,0,526.84,284.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.56,289.53s0-.12.06-.1a26.3,26.3,0,0,1,13.82,11.95c.1.19,0,.47-.14.25C534.07,298,527.14,292.07,522.56,289.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.11,307.86c-3-5.35-7.44-9.2-12.56-12.5-.07,0,0-.13.07-.11,2.94.93,6,3.38,8.19,5.48a16.26,16.26,0,0,1,4.49,7C532.33,307.86,532.18,308,532.11,307.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.09,294.57c.12.18-.27.16-.16.35.49.77,3,5.68,1.6,7.06-1.13,1.1-3.4.35-4.15-.28l-1.9-1.59,1.23,2.15a10.38,10.38,0,0,1,1.18,3.06,3.67,3.67,0,0,1-.48,2.93,2.07,2.07,0,0,1-2.49.76,6.35,6.35,0,0,1-2.49-1.91l-1.87-2.26,1,2.73a9.52,9.52,0,0,1,.56,2.37,3.89,3.89,0,0,1-.33,2.24,1.85,1.85,0,0,1-1.69,1,4,4,0,0,1-2.07-1,32.23,32.23,0,0,1-3.54-3.65c-.58-.64-1.15-1.28-1.75-1.9a6.19,6.19,0,0,0-2.06-1.54,6.62,6.62,0,0,1,1.88,1.7c.55.66,1.07,1.34,1.59,2a28.09,28.09,0,0,0,3.42,3.92,4.92,4.92,0,0,0,2.45,1.29,2.67,2.67,0,0,0,2.56-1.38,4.77,4.77,0,0,0,.48-2.77,10.5,10.5,0,0,0-.59-2.64l-.84.48a7,7,0,0,0,2.91,2.29,3,3,0,0,0,2,.07,3.39,3.39,0,0,0,1.6-1.2,4.61,4.61,0,0,0,.61-3.71,11.33,11.33,0,0,0-1.35-3.35l-.67.57c1,.77,3.43,1.89,5.4.4C544.46,300.44,540.82,295.44,540.09,294.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540,294.57a6.42,6.42,0,0,0,1.77.55,1.41,1.41,0,0,0,1.33-.5,2.88,2.88,0,0,0,.41-1.57c0-.61,0-1.25-.07-1.91a4.6,4.6,0,0,1,.72,1.86,2.81,2.81,0,0,1-.39,2.13,2,2,0,0,1-1,.67,2.08,2.08,0,0,1-1.14,0A3.23,3.23,0,0,1,540,294.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.91,298.66,539,326.41s23.18,12.47,30,12.12,30.87-12.86,41.38-20.06,5.76-11.38-3.89-9.78-33.3,5.2-34.17,4.93S552.91,298.66,552.91,298.66Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.35,321.91a5.85,5.85,0,0,0,0,3.93,5.69,5.69,0,0,0,0-3.93Zm-20.56-.48a5.85,5.85,0,0,0,0,3.93,5.69,5.69,0,0,0,0-3.93Zm34.08.28a5.38,5.38,0,0,0-2,.35,5.82,5.82,0,0,0,3.92,0A5.41,5.41,0,0,0,589.87,321.71Zm-31.77-16.1a5.38,5.38,0,0,0-2,.35,5.82,5.82,0,0,0,3.92,0A5.41,5.41,0,0,0,558.1,305.61Zm6.45,26.54a5.38,5.38,0,0,0-2,.35,5.82,5.82,0,0,0,3.92,0A5.41,5.41,0,0,0,564.55,332.15Zm33.39-19a5.31,5.31,0,0,0-1.63-1.14,5.68,5.68,0,0,0,2.78,2.77A5.51,5.51,0,0,0,597.94,313.15Zm-31.19,2.29a5.31,5.31,0,0,0-1.63-1.14,5.68,5.68,0,0,0,2.78,2.77A5.51,5.51,0,0,0,566.75,315.44ZM544,326.08a5.31,5.31,0,0,0-1.63-1.14,5.68,5.68,0,0,0,2.78,2.77A5.51,5.51,0,0,0,544,326.08Zm62-9.24a5.17,5.17,0,0,0-1.15,1.63,5.75,5.75,0,0,0,2.78-2.78A5.33,5.33,0,0,0,606,316.84Zm-24.66-3.06a5.17,5.17,0,0,0-1.15,1.63,5.19,5.19,0,0,0,1.63-1.14,5.38,5.38,0,0,0,1.15-1.64A5.22,5.22,0,0,0,581.3,313.78Zm-34.5-.63a5.17,5.17,0,0,0-1.15,1.63,5.19,5.19,0,0,0,1.63-1.14,5.38,5.38,0,0,0,1.15-1.64A5.22,5.22,0,0,0,546.8,313.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.88,318.67c1.62-3.29,3.22-6.6,5-9.83,1-1.83,2-3.68,3-5.5,0-.07.16,0,.12.05-1.49,3.37-3,6.75-4.66,10.05s-3.26,6.58-4.94,9.84q-1.44,2.79-3,5.47s-.09,0-.07,0C546.62,325.3,548.24,322,549.88,318.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.25,311.84c-.23,1.7-2,4-5.93,6.63-10.51,7.2-34.59,19.71-41.38,20.06-2.43.13-7-1.39-11.79-3.39C571.71,329.52,597.93,318.81,616.25,311.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587,371,647,377.91c0-1.23-6.93-37.63-13-51.18-7.73-17.38-12-18.9-14.51-19.91-3.24-1.29-9.1-.91-10.51-.3-1.6.68-6.91,9.25-8.92,15.6C596.09,334.86,586.17,370.16,587,371Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.67,362.87a5.17,5.17,0,0,0-1.15,1.63,5.19,5.19,0,0,0,1.63-1.14,5.38,5.38,0,0,0,1.15-1.64A5.22,5.22,0,0,0,620.67,362.87Zm-14.71-46a5.17,5.17,0,0,0-1.15,1.63,5.75,5.75,0,0,0,2.78-2.78A5.33,5.33,0,0,0,606,316.84ZM592,357.5a5.31,5.31,0,0,0-1.14,1.63,5.71,5.71,0,0,0,2.77-2.77A5.43,5.43,0,0,0,592,357.5Zm43.45-17a5.17,5.17,0,0,0-1.63-1.15,5.64,5.64,0,0,0,2.78,2.78A5.51,5.51,0,0,0,635.47,340.51Zm-11.65-22.89a5.35,5.35,0,0,0-1.64-1.14,5.33,5.33,0,0,0,1.15,1.63,5.51,5.51,0,0,0,1.63,1.15A5.35,5.35,0,0,0,623.82,317.62ZM595.29,369.7a5.14,5.14,0,0,0-1.63-1.14,5.71,5.71,0,0,0,2.77,2.77A5.31,5.31,0,0,0,595.29,369.7ZM611,339.75a5.31,5.31,0,0,0-1.63-1.14,5.68,5.68,0,0,0,2.78,2.77A5.51,5.51,0,0,0,611,339.75Zm23.67,29.85a5.23,5.23,0,0,0-2,.34,5.45,5.45,0,0,0,2,.35,5.26,5.26,0,0,0,2-.35A5.25,5.25,0,0,0,634.66,369.6Zm-11.79-23.3a5.41,5.41,0,0,0-2,.35,5.82,5.82,0,0,0,3.92,0A5.38,5.38,0,0,0,622.87,346.3Zm-27-3.17a5.38,5.38,0,0,0-2,.35,5.82,5.82,0,0,0,3.92,0A5.41,5.41,0,0,0,595.88,343.13Zm13.48,26.12a5.41,5.41,0,0,0-2,.35,5.82,5.82,0,0,0,3.92,0A5.41,5.41,0,0,0,609.36,369.25Zm25-41.76a4,4,0,0,0-1.14.29,5,5,0,0,0,1.39.31Zm-23.09-1.94a5.21,5.21,0,0,0-2,.35,5.4,5.4,0,0,0,2,.34,5.16,5.16,0,0,0,2-.34A5,5,0,0,0,611.32,325.55Zm5.29-19.42-.54-.06a8.55,8.55,0,0,0-.07,1,5.25,5.25,0,0,0,.34,2,5.47,5.47,0,0,0,.35-2A7.61,7.61,0,0,0,616.61,306.13ZM606.2,353.82a5.82,5.82,0,0,0,0,3.92,5.66,5.66,0,0,0,0-3.92Zm28.81-.75a5.66,5.66,0,0,0,0,3.92,5.82,5.82,0,0,0,0-3.92Zm-37-24.18c-.12.42-.25.85-.38,1.28v0c0,.16,0,.33,0,.49a5.23,5.23,0,0,0,.34,2,5.45,5.45,0,0,0,.35-2A5.59,5.59,0,0,0,598.06,328.89Zm25.51,1.79a5.85,5.85,0,0,0,0,3.93,5.69,5.69,0,0,0,0-3.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.12,313.37c9.45,10.45,32.18,49.89,24.65,56.89s-48.52-3.25-60-8.95c-3.41-1.69,10-22.91,14.05-23.35,3.37-.36,20.44,7.79,21,6.81s-2-9.41-5.92-24.42C617.38,303.05,624,308.75,628.12,313.37Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.87,330.77c-8.34-1.3-10.68-.35-17.13-5.19-4.24-3.17-8.08-1.83-5.72,3.14,3.87,8.13,14.28,12.06,18.28,12.39Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.93,339.17s-9.3-5.36-18-7.63c-6-1.56-19.59-3.5-32.79,9.68-3.13,3.12-5.37,9.79,1.6,6.55,4.94-2.31,7.38-5.27,10.51-6.09,0,0-1.85,8.83,1.4,11.84a80.45,80.45,0,0,0,9.07,7.27,17.31,17.31,0,0,0,1.51-1.57s3.3,2.53,9.61,2Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.87,331c-2.93,1.47-9.08,4.68-13.2,9.06-4.58,4.86-12.08,15.47-8.46,18.81,2.66,2.45,5.88-1.35,5.88-1.35s-2.18,5,.71,6.72c2.63,1.54,4.94-1.55,4.94-1.55s-.79,3.29,2,4.28c3.39,1.2,4.5-5.88,9-7.63C589.75,358.91,587.87,331,587.87,331Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.61,344a26.55,26.55,0,0,0-8.56,13.35c0,.13.05.23.11.11a65.19,65.19,0,0,1,8.5-13.42S580.64,344,580.61,344Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.39,348.77c-2,1.8-6.58,7.82-7.75,13.84,0,.13.06.22.11.1a70.1,70.1,0,0,1,7.69-13.9S585.41,348.75,585.39,348.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.2,341.63c-2.74.76-4.53,2.06-6.86,3.62a37.68,37.68,0,0,1-3.54,2.17c-1.12.58-2.77,1.46-3.94.5a2.24,2.24,0,0,1-.46-2.23,11,11,0,0,1,1.55-3.08s0-.08-.06,0a14.78,14.78,0,0,0-1.69,2.73,3.69,3.69,0,0,0-.28,2.12c.38,1.51,2.15,1.73,3.41,1.34a11.74,11.74,0,0,0,2.16-1c.66-.37,1.31-.77,2-1.18,1.31-.86,2.57-1.79,3.86-2.65a34.53,34.53,0,0,1,3.94-2.21S573.25,341.61,573.2,341.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.34,351.12a85.91,85.91,0,0,1,5.91-9.43s0-.08,0-.05a44.46,44.46,0,0,0-6.48,9,15,15,0,0,0-1.78,5.72c-.05,2.84,1.83,3.41,2.52,3.56a3.72,3.72,0,0,0,2.43-.35,7.45,7.45,0,0,0,2.23-2,0,0,0,0,0-.06-.06c-1,1.11-2.66,2.19-4.2,2a2.55,2.55,0,0,1-1.74-1,3.34,3.34,0,0,1-.42-2.3A15.55,15.55,0,0,1,567.34,351.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.93,339.17l-13.62,27.49s51.32,12.41,55.91,3.51-14.84-44.31-23.69-54.67c-10.26-12-11.66-8-9.52,2.52,2.23,11,6.62,27,6.62,27Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.67,362.87a5.17,5.17,0,0,0-1.15,1.63,5.19,5.19,0,0,0,1.63-1.14,5.38,5.38,0,0,0,1.15-1.64A5.22,5.22,0,0,0,620.67,362.87Zm14.8-22.36a5.17,5.17,0,0,0-1.63-1.15,5.64,5.64,0,0,0,2.78,2.78A5.51,5.51,0,0,0,635.47,340.51Zm-11.65-22.89a5.35,5.35,0,0,0-1.64-1.14,5.33,5.33,0,0,0,1.15,1.63,5.51,5.51,0,0,0,1.63,1.15A5.35,5.35,0,0,0,623.82,317.62ZM646.17,364a5.14,5.14,0,0,0-1.63-1.14,5.71,5.71,0,0,0,2.77,2.77A5.31,5.31,0,0,0,646.17,364Zm-34.76-23.75-.28.56a4.22,4.22,0,0,0,1,.6A4.86,4.86,0,0,0,611.41,340.22Zm23.25,29.38a5.23,5.23,0,0,0-2,.34,5.45,5.45,0,0,0,2,.35,5.26,5.26,0,0,0,2-.35A5.25,5.25,0,0,0,634.66,369.6Zm13.23-19.53a5.41,5.41,0,0,0-2,.35,5.82,5.82,0,0,0,3.92,0A5.38,5.38,0,0,0,647.89,350.07Zm-25-3.77a5.41,5.41,0,0,0-2,.35,5.82,5.82,0,0,0,3.92,0A5.38,5.38,0,0,0,622.87,346.3Zm12.36-18.87a5.21,5.21,0,0,0-2,.35,5.4,5.4,0,0,0,2,.34,5.16,5.16,0,0,0,2-.34A5,5,0,0,0,635.23,327.43Zm-29,26.39a5.82,5.82,0,0,0,0,3.92,5.66,5.66,0,0,0,0-3.92Zm28.81-.75a5.66,5.66,0,0,0,0,3.92,5.82,5.82,0,0,0,0-3.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.17,352.65a61.26,61.26,0,0,0-7.44-4.53,58.75,58.75,0,0,0-7.94-3.34c-1.55-.54-3.12-1-4.69-1.47-.05,0-.07.05,0,.07a76.56,76.56,0,0,1,8,3.27q3.9,1.82,7.73,3.77c1.45.74,2.86,1.55,4.28,2.33C643.18,352.79,643.23,352.7,643.17,352.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.07,339.09c.26.08,14.27,5,14.73,5.18-.06-.21-2.47-7.75-2.83-8.85,0-.11-.06-.22-.1-.33-.25-.49-.5-1-.73-1.49l-.87-1.94s0,0,0,0c.32.63.64,1.26,1,1.89.15.3.29.59.42.89-.24-.78-.46-1.56-.69-2.34-.35-1.25-.67-2.51-1-3.77,0,0,0-.05.06,0,.72,2.2,1.5,4.37,2.22,6.57s3.48,10.28,3.46,10.27-15.43-5.72-15.72-5.85A.1.1,0,0,1,612.07,339.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.82,357.15c1.5-3.07,3-6.15,4.59-9.16.92-1.71,1.83-3.43,2.76-5.14,0-.06.15,0,.12.06-1.38,3.14-2.78,6.28-4.3,9.36s-3,6.13-4.57,9.17q-1.33,2.6-2.82,5.1a0,0,0,1,1-.06,0C607.82,363.33,609.31,360.24,610.82,357.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.64,367.08c.53-.84,1.2-2.06,1.76-2.88.15-.22.32-.17.2.06-.4.77-.74,1.63-1.14,2.42l2.16.46,2.5.57c1.63.36,3.26.71,4.9,1q5,1,10,1.79a193.68,193.68,0,0,0,20.23,2.23c1.9.1,3.79.17,5.69.17a52.32,52.32,0,0,0,5.61-.18,0,0,0,0,1,0,.09,30.9,30.9,0,0,1-4.89.56c-1.71,0-3.44.06-5.15,0-3.43-.1-6.85-.38-10.25-.74-6.75-.73-13.47-1.76-20.14-3.05-1.86-.36-3.73-.74-5.59-1.15l-2.81-.63A17.43,17.43,0,0,1,597.64,367.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.05,319c3.47.68,9.16-4.8,11.33-9.15.15-.3-.42-3.35-.93-7.1-.3-2.28-.58-4.82-.67-7.16,0-.48-14.53,4.13-14.53,4.13a37.17,37.17,0,0,1,1.76,8.92,5,5,0,0,1-.06,1,.78.78,0,0,0,0,.16C603.71,311.6,603.7,318.34,607.05,319Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.88,295.69c-.53,4-2.62,13.62-10.44,14.1a9.2,9.2,0,0,1-1.5,0,.42.42,0,0,1,0-.16,5.86,5.86,0,0,0,.07-1,37.63,37.63,0,0,0-1.77-8.93S612.72,296.39,615.88,295.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.77,280.06c1.16,5.31-2.78,20.08-6.74,23.12-5.74,4.41-14.53,4.17-18.13-2.59-3.48-6.55,2-25.7,6.36-28.4C607.69,268.21,618,272.21,619.77,280.06Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.36,288s.06.07,0,.11c-.33,1-.54,2.15.25,2.75,0,0,0,.07,0,.05C603.59,290.46,603.89,288.9,604.36,288Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.55,287.27c1.62.36.78,3.57-.72,3.24S604.19,287,605.55,287.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.78,286.61s-.09,0-.1.07c-.23,1-.66,2.11-1.65,2.21a0,0,0,0,0,0,.06C598.17,289.08,598.72,287.6,598.78,286.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.16,285.34c-1.57-.54-2.53,2.64-1.08,3.14S599.48,285.79,598.16,285.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.7,285.11a12.78,12.78,0,0,1-1.25-.55,2.25,2.25,0,0,1-1.17-.8.71.71,0,0,1,.18-.84,1.77,1.77,0,0,1,1.77-.05,2.58,2.58,0,0,1,1.38,1.22A.75.75,0,0,1,607.7,285.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.3,282.61c.46,0,.9,0,1.36,0a2.23,2.23,0,0,0,1.39-.27.69.69,0,0,0,.18-.83,1.74,1.74,0,0,0-1.6-.76,2.61,2.61,0,0,0-1.76.55A.75.75,0,0,0,597.3,282.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.61,297.72a1.6,1.6,0,0,1-1,.37,2.76,2.76,0,0,1-1-.53,0,0,0,0,0-.06,0,1.39,1.39,0,0,0,1.12.87,1.12,1.12,0,0,0,1-.68C603.73,297.74,603.66,297.7,603.61,297.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.34,294.47a3.52,3.52,0,0,1-2.65.92,4.44,4.44,0,0,1-1.24-.27l-.22-.08L599,295a.26.26,0,0,1-.15-.28h0a.54.54,0,0,1,0-.1h0l0-.09c.18-.77.56-1.92.56-1.92-.32.07-1.92.34-1.79-.06a52.63,52.63,0,0,1,4-9.92.09.09,0,0,1,.17.08c-.89,3.17-2.34,6.17-3.29,9.35a6.37,6.37,0,0,1,1.72-.07c.1.06-.77,2.21-.82,2.56v0a4.85,4.85,0,0,0,3.79-.18C603.36,294.31,603.42,294.4,603.34,294.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,294.85a4.22,4.22,0,0,0,1.29,1.67,1.91,1.91,0,0,0,1.08.36c.85,0,1.06-.73,1.08-1.39a4.71,4.71,0,0,0-.11-1.05A5.4,5.4,0,0,1,600,294.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.29,296.52a1.91,1.91,0,0,0,1.08.36c.85,0,1.06-.73,1.08-1.39A1.92,1.92,0,0,0,601.29,296.52Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.05,292.94s5-9,4.33-14.11c-.31-2.3-3.52-3.73-3.52-3.73s-10.63-9.53-21.26-1.49c-1.26,1-4.33,4,1.19,6.22s16.1-.57,16.1-.57a37.64,37.64,0,0,0,.58,11.19A3.44,3.44,0,0,0,618.05,292.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.58,292s3.87-4.49,5.94-3.07-1.17,8.18-3.85,8.88a2.62,2.62,0,0,1-3.36-1.76Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.54,290.86a0,0,0,0,1,0,.07c-1.88.55-3,2.13-3.84,3.8a1.45,1.45,0,0,1,2.2-.18.05.05,0,0,1,0,.09A1.64,1.64,0,0,0,617,295a8.22,8.22,0,0,0-1,1.35c-.1.16-.38,0-.3-.14l0,0C615.93,293.88,618.05,290.84,620.54,290.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598,271.56c1.69.09,10.36,3,13.78,5.83s8.7,10.61,9,11,6.38-13.48-4.52-19.61C604.31,262.12,598,271.56,598,271.56Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.21,287.61s-4.68-12.5-8.27-16.12-12.82-7.8-19.55-7c-5.25.66,4.28,10,4.28,10a3.36,3.36,0,0,1,2.48-1.7c3.24-.28,8.47,2.25,11.29,4.24C614,279.58,620.21,287.61,620.21,287.61Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.21,287.61s-4.68-12.5-8.27-16.12-12.82-7.8-19.55-7c-5.25.66,4.28,10,4.28,10a3.36,3.36,0,0,1,2.48-1.7c3.24-.28,8.47,2.25,11.29,4.24C614,279.58,620.21,287.61,620.21,287.61Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.75,318.9C239,340,268.52,393.35,272.17,401c2.48,5.19-24.69,18.89-25.84,15.11-1.48-4.84-25.14-64.57-31.42-87.11C211.44,316.58,214.56,314.54,218.75,318.9Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.05,412.55c.95,2.59,4.17,13.58,6.43,14.95s14.09,1.07,20.06,1.07,7.14-1.66,7-3.71S266,422.41,266,422.41s16.72,4.79,20.93,5.58,13.9,3.23,15.3-.26c.63-1.58-2-3.17-2-3.17s4.06,1.19,4.71-.83c.73-2.3-2.5-3.57-2.5-3.57s2.54.51,2.6-1.36c.13-4.19-15.77-6.25-15.77-6.25s12.18,5.93,12.57,2.51c.54-4.73-24.42-9.92-27-12a17.7,17.7,0,0,1-4.17-5.14Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.49,425.9a1.84,1.84,0,0,0-.56-1.6,5.3,5.3,0,0,0-1.46-.94,19.26,19.26,0,0,0-3.42-1.11c-2.35-.6-4.76-1-7.16-1.64a29.1,29.1,0,0,1,7.37.83,13.38,13.38,0,0,1,3.51,1.34,4.58,4.58,0,0,1,1.47,1.27A1.88,1.88,0,0,1,278.49,425.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.17,424.56c-1.72-.42-3.42-.9-5.11-1.39s-3.38-1-5.06-1.52l-5-1.58-5-1.55a40.19,40.19,0,0,1,5.22.93c1.73.4,3.42.89,5.11,1.4s3.37,1.08,5,1.71S298.56,423.82,300.17,424.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.94,414.34a34,34,0,0,1,4.83.67,46.07,46.07,0,0,1,4.72,1.22,40.92,40.92,0,0,1,4.56,1.7,34,34,0,0,1,4.33,2.23c-1.53-.53-3-1.12-4.56-1.63s-3.05-1-4.58-1.51-3.08-.93-4.62-1.39S285.51,414.77,283.94,414.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,410.35a30,30,0,0,1,7.68,1.62,29.63,29.63,0,0,1,7.07,3.43c-2.48-.89-4.88-1.82-7.34-2.63S288.9,411.16,286.4,410.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.09,341,220,357.09s-6.31-19-8.25-30.83,3.7-14.45,11.16-5.93A205,205,0,0,1,238.09,341Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.09,341,220,357.09s-6.31-19-8.25-30.83,3.7-14.45,11.16-5.93A205,205,0,0,1,238.09,341Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.52,338.44c-.58.54-1.25,1-1.86,1.48s-1.23,1-1.83,1.53l-3.51,3c-2.39,2-4.81,3.94-7.09,6.08,0,0,0,.1,0,.07a73.6,73.6,0,0,0,7.35-5.65c1.19-1,2.36-2,3.53-3.07.59-.52,1.18-1.06,1.75-1.62s1.1-1.18,1.69-1.69C233.64,338.48,233.57,338.4,233.52,338.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.29,438.09c-.07,2.28,6.46,2.66,9.11,1.07a61.25,61.25,0,0,0,6-5.4c6.28-6,14.94-14.86,14.94-14.86l6.8,2.72,33.08,9.48,12.26-36.17s-16.07-6-31.33-11.36c-2.35-.82-4.66-1.62-6.91-2.38l-.42-.15c-10.23-3.45-18.7-6-19.53-5.39C146.09,377.35,124.37,435.79,124.29,438.09Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.29,438.09c-.08,2.29,6.46,2.66,9.11,1.08a62.5,62.5,0,0,0,6-5.42c6.28-6,14.94-14.85,14.94-14.85l6.8,2.72,1.1.31,13.4-38.19a4.75,4.75,0,0,0-.49-.17c-2.35-.82-4.66-1.61-6.91-2.38l-.42-.15c-10.23-3.44-18.7-6-19.54-5.39C146.09,377.35,124.37,435.8,124.29,438.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75,439c0-2.34,21.42-62.11,23.68-63.87.84-.68,9.74,1.92,20.39,5.38l.33.11-13.36,38.72-.65-.25s-18.41,19.22-21.1,20.9S123.7,441.29,123.75,439Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.31,439.1c3.85-10,18.44-50.63,21.49-60.8,0-.08,0-.1-.07,0-4,9.82-18.29,50.58-21.59,60.77C126.07,439.26,126.23,439.32,126.31,439.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.15,423.55c2.16-3.7,3.28-8.77,1.54-12.81-.07-.16-.29-.06-.3.08a58.92,58.92,0,0,1-1.74,12.53A.27.27,0,0,0,153.15,423.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.4,425.79c2.16-3.7,3.28-8.77,1.54-12.81-.07-.15-.29-.05-.29.09a59,59,0,0,1-1.75,12.53A.27.27,0,0,0,150.4,425.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.65,428c2.16-3.7,3.28-8.77,1.54-12.81-.06-.16-.29-.06-.29.08a59.57,59.57,0,0,1-1.74,12.53A.27.27,0,0,0,147.65,428Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,431.8c2.71-.8,2.78-4,2-6.2a22.49,22.49,0,0,0-6.9-9.35c-.07-.06-.14,0-.18,0a.52.52,0,0,0-.71.45c0,3.71-.38,7.67.8,11.26C155.63,430.09,157.4,432.54,160,431.8Zm-4.6-9.45c-.07-1.83,0-3.64-.17-5.46,1.34,1.83,2.75,3.59,3.91,5.55a23.61,23.61,0,0,1,1.51,2.91c.66,1.57,1.27,7-2.83,4.8C155.51,428.91,155.43,424.52,155.35,422.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.67,406.54c-2.56,2.77-3.84,6.55-5.42,9.91a.52.52,0,0,0,.47.7.12.12,0,0,0,.15.11A22.4,22.4,0,0,0,165,411.62c1.62-1.62,2.9-4.6.78-6.45S161.16,404.92,159.67,406.54Zm3.47-.78c4.66-.34,1.82,4.39.58,5.54a24,24,0,0,1-2.59,2,67.57,67.57,0,0,1-5.87,3.43c.88-1.6,1.61-3.27,2.43-4.9C158.66,409.91,160.56,406,163.14,405.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75,439c0,2.34,6.61,2.65,9.29,1S154.15,419,154.15,419l.64.25,10.56-30.6L142,387.57C134.91,405.7,123.77,437.27,123.75,439Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.39,428s71.6,13.29,97.49,7.49c12.39-2.78,20.73-19.22,14.21-31.28-6.09-11.24-40.81-21.45-50.77-27.8-3.13-2-3.16-10.39-3.16-10.39l-25.42.73s-8.45,14.77-4.32,21.61a2.36,2.36,0,0,0,.24.34L184,384.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.28,408.11c2.57-6.26,5.42-12.4,8-18.63.05-.12.24-.07.19.06-2.45,6.28-4.7,12.63-7.26,18.87s-5.38,12.41-8.09,18.61c-.07.16-.32.09-.26-.08C177.38,420.67,179.73,414.35,182.28,408.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5,389c1.79.95,3.51,2.06,5.26,3.09s3.46,2,5.22,3c3.55,1.91,7.18,3.69,10.85,5.37a180.89,180.89,0,0,0,22.79,8.7c4.34,1.32,8.73,2.6,13.17,3.51.1,0,.06.17,0,.15-3.23-.63-6.47-1.25-9.67-2,1.72,1,3.42,2,5.13,3,.09.05,0,.19-.07.14-1.88-1-3.77-2-5.63-3.06a.17.17,0,0,1-.06-.25l-1.64-.41c-4-1.05-7.9-2.24-11.77-3.62a142.86,142.86,0,0,1-22.15-10.05c-2-1.12-4-2.28-5.92-3.48a52.66,52.66,0,0,1-5.64-3.82C195.19,389.08,195.36,388.88,195.5,389Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,448c-.07,2.29,6.46,2.66,9.11,1.08a63.33,63.33,0,0,0,6-5.41c6.27-6,14.93-14.86,14.93-14.86l6.81,2.72L166.44,441l13.23-36.18s-16.07-6-31.33-11.36c-2.35-.82-4.66-1.61-6.91-2.38l-.42-.15c-10.23-3.45-18.7-6-19.53-5.39C119.24,387.22,97.52,445.66,97.44,448Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,448c-.07,2.28,6.46,2.66,9.11,1.07a61.25,61.25,0,0,0,6-5.4c6.27-6,14.94-14.86,14.94-14.86l6.79,2.73.91.27,14-38-.87-.3L141.43,391l-.42-.14c-10.24-3.45-18.7-6-19.53-5.38C119.24,387.21,97.52,445.65,97.44,448Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.87,448.49c.08-2.34,22.27-61.82,24.56-63.54.85-.67,9.71,2.06,20.31,5.66l.34.12-13.9,38.53-.64-.26s-18.68,19-21.39,20.6S96.79,450.83,96.87,448.49Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.43,448.68c4-9.94,19.13-50.38,22.32-60.5,0-.09,0-.11-.06,0-4.17,9.76-19,50.33-22.43,60.47C99.19,448.83,99.34,448.89,99.43,448.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.48,433.49c2.21-3.67,3.4-8.72,1.72-12.79-.07-.15-.29-.06-.3.09a58.88,58.88,0,0,1-1.91,12.5A.27.27,0,0,0,126.48,433.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7,435.7c2.21-3.67,3.4-8.72,1.72-12.79-.07-.16-.29-.06-.3.08a59,59,0,0,1-1.91,12.51A.27.27,0,0,0,123.7,435.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.92,437.9c2.21-3.67,3.41-8.72,1.72-12.78-.07-.16-.29-.06-.3.08a58.79,58.79,0,0,1-1.91,12.5A.27.27,0,0,0,120.92,437.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.17,441.83c2.71-.75,2.83-4,2.06-6.16a22.44,22.44,0,0,0-6.77-9.45c-.07-.06-.14,0-.18,0a.52.52,0,0,0-.72.44c0,3.7-.48,7.67.65,11.27C128.87,440.07,130.6,442.54,133.17,441.83Zm-4.47-9.51c0-1.82,0-3.64-.1-5.46a66.85,66.85,0,0,1,3.83,5.61,23,23,0,0,1,1.48,2.93c.63,1.57,1.17,7.07-2.9,4.76C128.77,438.88,128.74,434.49,128.7,432.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.23,416.58c-2.6,2.73-3.92,6.5-5.55,9.83a.54.54,0,0,0,.46.71c0,.07.05.13.14.11a22.37,22.37,0,0,0,10.24-5.5c1.65-1.6,3-4.56.87-6.44S134.75,415,133.23,416.58Zm3.48-.73c4.67-.28,1.77,4.41.51,5.54a24.08,24.08,0,0,1-2.62,2c-1.89,1.28-3.92,2.26-5.91,3.34.9-1.59,1.65-3.24,2.49-4.86C132.18,419.93,134.14,416,136.71,415.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.42,366.17l-43.71,1.19s-8.28,24-4.14,30.82,44.79,15.17,44.79,15.17l-56.2-18.7-16.62,43.16s67.87,11.82,103.39,6.67c13.32-1.93,21-19.77,12.58-32.87-8.85-13.79-39.6-31.86-39.6-31.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.59,394.48c17.26,7,34.65,13.69,52.39,19.4q3.69,1.2,7.4,2.35c2.57.8,5.12,1.74,7.73,2.35.13,0,.07.24-.06.2-2.26-.74-4.59-1.24-6.88-1.89s-4.48-1.27-6.71-1.94l-2.89-.89.59.37c.9.55,1.79,1.09,2.68,1.66,1.82,1.17,3.52,2.57,5.43,3.6.11.07,0,.25-.11.18-1.81-1.18-3.84-2-5.7-3.14-.9-.53-1.79-1.09-2.67-1.67a16.39,16.39,0,0,1-2.35-1.66c-2.83-.88-5.65-1.77-8.45-2.71-8.84-2.95-17.59-6.14-26.23-9.63q-7.24-2.91-14.35-6.14C158.16,394.81,158.34,394.37,158.59,394.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.44,417.64c2.56-6.26,5.41-12.39,8-18.63.05-.12.24-.06.2.06-2.46,6.28-4.7,12.64-7.26,18.87s-5.38,12.41-8.09,18.61c-.07.16-.33.09-.26-.08C149.54,430.2,151.88,423.88,154.44,417.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.72,380.17a119.71,119.71,0,0,1,14.19,8.58c4.51,3.06,8.9,6.32,13.1,9.8,2.12,1.76,4.18,3.61,6.17,5.51a45.09,45.09,0,0,1,5.27,5.86,21.35,21.35,0,0,1,4.19,13.17,22.59,22.59,0,0,1-1.43,7.36,27,27,0,0,1-3.78,6.42c-.06.07-.18,0-.11-.11a17.25,17.25,0,0,0,3.16-6.12A22.59,22.59,0,0,0,256,411.48c-2.87-4.33-7-7.86-10.86-11.25s-8.23-6.75-12.59-9.83c-2.44-1.72-4.93-3.39-7.43-5s-5.06-3.21-7.51-4.93A.16.16,0,0,1,217.72,380.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.1,382.47a51.11,51.11,0,0,1,11.07-2.61c3.71-.57,7.43-.93,11.17-1.14.1,0,.1.14,0,.16-3.78.49-7.55,1.13-11.29,1.85s-7.24,1.65-10.9,2.09C204.94,382.85,204.92,382.54,205.1,382.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,384.24a55.7,55.7,0,0,0,6.93-.92,11.49,11.49,0,0,0,5.38-2c3-2.46,4.09-6.6,4.59-10.27,0-.09.16-.07.15,0-.36,4-.34,8.55-3.72,11.36a10.52,10.52,0,0,1-5.85,2.11,36.67,36.67,0,0,1-7.48-.15A.09.09,0,0,1,175.42,384.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.88,390.74a46.69,46.69,0,0,1,.93-6.87c.45-2.33,1-4.63,1.65-6.92.72-2.59,1.57-5.14,2.47-7.68,0-.09.18-.06.15,0-1.26,4.28-2.39,8.61-3.31,13-.45,2.17-.85,4.34-1.19,6.53a13.46,13.46,0,0,0,.23,6.34,11.21,11.21,0,0,0,3.73,5.3s0,0,0,0A11.43,11.43,0,0,1,170.88,390.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,404c3,.64,5.91,1.54,8.85,2.35s5.88,1.64,8.81,2.48c5.87,1.69,11.73,3.44,17.58,5.19,3.32,1,6.62,2.06,9.93,3.11.09,0,0,.18,0,.15q-17.72-4.68-35.23-10.05c-3.31-1-6.67-1.93-9.93-3.13A.05.05,0,0,1,164,404Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.37,374.78c1.7,1.18,60,2.05,60,2.05l-.64-20.53s4.95-5,5.26-11.23c.41-8.28-9.95-25.27-10.85-26.35-3.57-4.35-7.8-5.59-12.12-4.75C190,317.47,166.37,374.78,166.37,374.78Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.47,327.66c.89,2,1.9,4,2.85,6-.31-1.38-.61-2.75-1-4.12,0,0,0,0,0,0a26.53,26.53,0,0,1,1.4,5.15,36.75,36.75,0,0,1,1.8,4.68,17.53,17.53,0,0,1,.85,5.93,15,15,0,0,1-1.59,5.78,38.72,38.72,0,0,1-3.77,5.86c-.18.25-.52,0-.37-.29,2.12-3.33,4.43-6.82,4.79-10.85s-1-7.88-2.4-11.56a56.83,56.83,0,0,0-2.77-6.53C225.28,327.63,225.43,327.57,225.47,327.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.43,351.06a56,56,0,0,0-8.45,1.1c-1.38.3-2.74.67-4.1,1.06-.67.2-1.35.38-2,.55a9.59,9.59,0,0,1-2.19.33.05.05,0,0,0,0,.1,14.59,14.59,0,0,0,2.09,0,15.11,15.11,0,0,0,2-.31c1.41-.3,2.8-.66,4.2-1,2.82-.62,5.65-1.25,8.51-1.67A.12.12,0,0,0,216.43,351.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35,353.8a63.48,63.48,0,0,0-7-.57c-1.18,0-2.35,0-3.52.09-.56,0-1.12.08-1.68.13s-1.22.2-1.83.25a.05.05,0,1,0,0,.1c.58,0,1.17,0,1.75,0l1.75,0,3.51,0c2.35,0,4.68,0,7,.11A.1.1,0,0,0,223.35,353.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.85,385.42q9.32-7.55,18.86-14.77c3.17-2.43,6.38-4.79,9.58-7.18l4.84-3.54,1.22-.88.69-.46a7,7,0,0,1,.78-.38l2.81-1.13c7.47-2.86,14.94-5.63,22.59-8,.49-.15,1-.3,1.47-.43l.38-.1a4.13,4.13,0,0,1,.44-.09,3.66,3.66,0,0,1,.57-.05h.27c.92,0,1.95-.12,2.93-.18l6-.48c4-.28,7.95-.66,11.94-.92-3.94.71-7.89,1.28-11.83,1.9l-5.94.8c-1,.13-2,.25-3,.32h-.48l-.17.07-.28.07-.34.11c-.46.13-.93.31-1.39.46-3.74,1.33-7.48,2.73-11.2,4.15s-7.46,2.81-11.16,4.27L277.59,360a5.85,5.85,0,0,0-.56.26l-.55.37-1.21.86L270.4,365l-9.77,6.91Q250.85,378.81,240.85,385.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.77,352.86c1.58.67,3.13,1.39,4.65,2.12.77.35,1.53.73,2.29,1a4.68,4.68,0,0,0,.52.18,4.18,4.18,0,0,0,.56.06l1.26.06c3.39.15,6.79.3,10.18.77a77.51,77.51,0,0,1-10.22.23l-1.29-.09a4.85,4.85,0,0,1-.7-.08,4.64,4.64,0,0,1-.68-.26c-.79-.38-1.54-.78-2.28-1.22A50.19,50.19,0,0,1,293.77,352.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.69,344.16c.79-.92,4.9-.45,6.07-.75s4.74-1.12,6.23-.83,2.91,6.36,2,8.15-5.51,1.12-7,1.37-4.5,1.77-5.91.74S307.23,345.87,308.69,344.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.52,331.16c4.08,19.09,16.83,43.78,20.48,46.69,6.77,5.41,33.4,2.36,41.22,1.73,3.17-.25-1-27.55-4.31-26.72-8.17,2.07-23.29,3.95-23.68,4.06-.83.21-19.63-27.21-24.08-31.9C199.89,314.21,198.68,322.57,200.52,331.16Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.26,352.58a3.58,3.58,0,0,1-.86,4.13,6.43,6.43,0,0,1,2.26,3.24c.58,2.27-2.73,4.18-2.73,4.18a7,7,0,0,1,1.93,3.65c.33,2.23-2.73,4.62-2.73,4.62a6.11,6.11,0,0,1-.33,4.28c-1.8,3.51-7.8,4-11.62,4.39s-15-2.17-17.16-2.44l-2.55-24.47s16.64-6.5,21.19-6.3C279.49,348,287,349.87,288.26,352.58Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.13,356.49c-4-1.17-8.18-1.08-12.33-1.22a.07.07,0,1,0,0,.14c4.13.1,8.18,1,12.3,1.27A.1.1,0,0,0,287.13,356.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.82,363.81a11.32,11.32,0,0,0-2.85-.15c-1,0-2,0-3,.1-2,.1-4.05.24-6.07.44-.09,0-.09.15,0,.15q3-.15,6.06-.17h3a13,13,0,0,0,2.86-.1A.15.15,0,0,0,286.82,363.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.05,372.4a7.45,7.45,0,0,0-2.58,0l-2.77.18c-1.84.1-3.69.21-5.53.25-.1,0-.1.15,0,.15,1.88,0,3.76-.05,5.63-.1.93,0,1.85-.05,2.77-.09a7,7,0,0,0,2.5-.3S286.09,372.41,286.05,372.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,368.25a4.86,4.86,0,0,0-1.88-4.1c1.39-.83,2.79-1.84,2.95-3.6s-1.16-3.08-2.45-3.85a2.33,2.33,0,0,0,.83-1.22,3.06,3.06,0,0,0,.05-.62,3,3,0,0,1-1.24,1.77c-.11.11,2.31,1.62,2.33,3.86,0,1.64-1.49,2.75-2.71,3.59-.07.05,2,1.78,1.73,4a6.37,6.37,0,0,1-2.56,4.2s.08.28.17.39.07,0,.05-.07-.07-.22-.07-.22.6-.46.78-.62a7.26,7.26,0,0,0,.94-1A4.93,4.93,0,0,0,289,368.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.61,351.15c1,1.18,2,2.4,3.06,3.6.52.59,1,1.23,1.54,1.73l.09.08,0,0-.08,0c-.13,0,0,0,0,0h.07l.15,0,.58-.09,1.17-.18c1.56-.22,3.12-.44,4.69-.6s3.13-.33,4.72-.41c-1.54.39-3.09.69-4.64,1s-3.1.53-4.66.77l-1.17.16-.58.08-.15,0h-.25a.46.46,0,0,1-.21-.09l-.09-.07-.13-.12a17.15,17.15,0,0,1-1.5-1.88C231.29,353.82,230.41,352.52,229.61,351.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.74,381c1.89-.19,3.79-.31,5.68-.43s3.79-.21,5.68-.3l5.68-.23c1.9-.08,3.79-.16,5.68-.31a39.85,39.85,0,0,1-5.64.88c-1.89.2-3.79.32-5.68.41s-3.8.14-5.7.13S239.64,381.12,237.74,381Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.2,343.6l-18.38,15.79s-6-19.05-7.71-31S203,314,210.36,322.7A203.34,203.34,0,0,1,225.2,343.6Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.2,343.6l-18.38,15.79s-6-19.05-7.71-31S203,314,210.36,322.7A203.34,203.34,0,0,1,225.2,343.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.68,341c-.59.53-1.26,1-1.89,1.45s-1.24,1-1.85,1.49c-1.19,1-2.37,1.95-3.56,2.91-2.42,2-4.88,3.85-7.19,5.95,0,0,0,.1,0,.08a74.64,74.64,0,0,0,7.44-5.53q1.82-1.47,3.58-3c.6-.52,1.2-1.05,1.78-1.6s1.12-1.16,1.72-1.66C220.8,341,220.73,340.94,220.68,341Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62,315.53c-.09,1,2.51,8.77,7,10,1.46.4,4-7.47,4-7.47l.32-.53,4.42-7.54-8.69-10.45S208.66,315.09,208.62,315.53Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.3,310l-4.43,7.54a17.56,17.56,0,0,1-6.63-12.66c1.19-2.7,2.19-4.94,2.34-5.27l0-.05,1.12,1.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.57,300.75c-3.1-.73-11.14,1.37-13.89,5.48s-2.62,10.84-1.25,11.52,7.31.26,11.41-1.92S214.1,301.12,212.57,300.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.58,300.77c.1,0,.12-.19,0-.2-2.73-.11-5.66.77-8.27,1.48a15.79,15.79,0,0,0-6,2.65,7.31,7.31,0,0,0-2.74,5.48,14.92,14.92,0,0,0,1.32,7.46c0,.06.15.05.13,0-1.18-4.56-2.2-10.12,2.36-13.14C203.27,301.89,208.18,301.66,212.58,300.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9,316.58c-2.73.3-9.89,5.38-11.15,10.54s2.82,12.88,4.14,13.45,7.42-4.3,9.44-7.91c1.35-2.41.36-5.27-.19-8.11C199.32,320.37,198.32,316.53,197.9,316.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,332c.89-5.26-2-10.53-3.74-15.32,0,0-.1,0-.09,0,.92,4.59,3.61,8.74,3.62,13.52a8.76,8.76,0,0,1-3.4,7.32c-2.05,1.47-4.61,2.12-7,2.92-.15.05-.06.28.1.23C196.2,339.26,201.06,337.47,202,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.3,317.05c.14-.06,0-.28-.09-.21-3.9,1.77-8.6,4.37-10.73,8.26-2.31,4.22-.13,8.7,1.81,12.57,0,.05.1,0,.08,0-1.91-3.92-3.92-8.78-1.31-12.88C189.31,321.22,193.62,318.79,197.3,317.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.21,340.44a11.66,11.66,0,0,1,4.27,8.18c.4,6.32,2.87,5.33,9.49,7.67,5.6,2,6.17,8.53,2.79,11.39,0,0,2.17-3.78-1.5-6.11-4.38-2.79-15.45,1-20-6.07C180.24,346.36,191.21,340.44,191.21,340.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.35,343.56c-.06-.09.09-.21.17-.12a9.5,9.5,0,0,1,1.59,2.89c.45,1.38.33,2.81.68,4.19.89,3.54,5,3.84,8,4.35,4,.69,6.95,3.46,6.77,7.7,0,.06-.1.06-.1,0a7.15,7.15,0,0,0-3.63-6.47c-2.24-1.23-4.93-1-7.3-1.81-1.62-.57-3.2-1.44-3.81-3.14a14.22,14.22,0,0,1-.46-2.92A9.88,9.88,0,0,0,193.35,343.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.08,341.09s.09,0,0,.06c-2.5,2-5.12,4-6.11,7.22-1.06,3.45.4,7.16,2.95,9.57,2.86,2.69,6.3,1.89,9.83,1.57a14.34,14.34,0,0,1,7.51.83c.07,0,0,.16-.06.13-3.87-1.32-7.61-.51-11.56-.27a7.86,7.86,0,0,1-7.41-3.84C181.32,350.46,184.72,344.53,190.08,341.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.23,297.86a1.09,1.09,0,0,0-1.71,1.34C209.37,300.32,211.08,299,210.23,297.86Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,299.71a1.09,1.09,0,0,0-1.71,1.34C210.18,302.17,211.89,300.83,211,299.71Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.17,301.41c-.84-1.11-2.55.23-1.71,1.34A1.09,1.09,0,0,0,212.17,301.41Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.48,302.9a1.09,1.09,0,0,0-1.71,1.34C212.62,305.36,214.33,304,213.48,302.9Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.06,304.18c-.85-1.12-2.56.22-1.71,1.34A1.09,1.09,0,0,0,215.06,304.18Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78,305.11a1.09,1.09,0,0,0-1.71,1.34A1.09,1.09,0,0,0,216.78,305.11Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.42,298.21c-.73,15.32-10,16.62-13.3,16.46-3-.15-13.19-1-14.05-16.35s6.49-19.82,13.37-19.85S240.14,282.88,239.42,298.21Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.22,295.6a9,9,0,0,1-1-.33,1.74,1.74,0,0,1-1-.54.56.56,0,0,1,.08-.67,1.35,1.35,0,0,1,1.36-.15,2,2,0,0,1,1.16.84A.58.58,0,0,1,237.22,295.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.75,295.67a9.32,9.32,0,0,0,1.05-.1,1.71,1.71,0,0,0,1.06-.3.56.56,0,0,0,.08-.66,1.35,1.35,0,0,0-1.29-.47,2,2,0,0,0-1.32.55A.58.58,0,0,0,226.75,295.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.64,298.2s-.09.05-.09.09c-.07,1-.32,2.23-1.29,2.48,0,0,0,.06,0,.06C228.43,300.78,228.74,299.2,228.64,298.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.81,297c-1.66-.28-2.11,3.06-.57,3.32S229.2,297.27,227.81,297Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.13,297.12c-.32.15-.65.44-1,.43s-.68-.4-.9-.78c0,0-.06,0-.06,0a1.22,1.22,0,0,0,.74,1.51c.61.17,1.14-.33,1.38-1C227.34,297.25,227.26,297.06,227.13,297.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.68,298.66s.07.06.07.11c-.18,1-.22,2.24.67,2.71,0,0,0,.07,0,.06C234.28,301.22,234.34,299.61,234.68,298.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.76,297.71c1.68.11,1.33,3.47-.22,3.37S234.35,297.62,235.76,297.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.43,298c.25.2.48.55.79.6s.68-.27.95-.59c0,0,.05,0,0,0,0,.64-.32,1.29-1,1.35s-.93-.54-1-1.19C236.22,298.09,236.33,297.92,236.43,298Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.28,307.35c.19.29.37.68.73.78a2.63,2.63,0,0,0,1.15,0,0,0,0,0,1,0,.06,1.41,1.41,0,0,1-1.42.28,1.11,1.11,0,0,1-.61-1.07C227.16,307.32,227.25,307.31,227.28,307.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.28,304s0,1.57-.12,2.3c0,.07-.2.07-.45.05h0a3.51,3.51,0,0,1-3.17-1.8.08.08,0,0,1,.12-.09,5.37,5.37,0,0,0,3,1.39c.08-.2-.06-2.7.06-2.69a6.13,6.13,0,0,1,1.59.62c.14-3.28-.25-6.56-.07-9.82a.1.1,0,0,1,.2,0,52.85,52.85,0,0,1,.52,10.57C234,304.9,232.56,304.12,232.28,304Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.72,306a4.27,4.27,0,0,1-1.78,1.23,1.87,1.87,0,0,1-1.17,0c-.84-.27-.82-1-.63-1.7a5.09,5.09,0,0,1,.43-1A5.6,5.6,0,0,0,231.72,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.94,307.25a1.87,1.87,0,0,1-1.17,0c-.84-.27-.82-1-.63-1.7A2,2,0,0,1,229.94,307.25Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,282.47a6.81,6.81,0,0,1-1,3.9c-2.31,3.08-6.22,1.36-7.9,2.42s-1.63,3.7-3.07,4.72c-2,1.41-4.1.28-4.61,1.4s-2,4.71-3.64,4.88-3.45-26.09,16-21.36c0,0,2.91-.56,6.66,2.38,4.13,3.25,4.6,11.22,4.6,11.22s-.07-.13-.62-.85c-.78-1-1-1.87-1.57-2.55-.92-1.07-1.58-.87-2.55-1.92A13.07,13.07,0,0,1,232.2,282.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.12,281.33a13.48,13.48,0,0,1,0,3.11,5.51,5.51,0,0,1-1,2.82,4.17,4.17,0,0,1-2.6,1.3c-1,.15-2,0-3.13.24a3.12,3.12,0,0,0-1.51.72,4.14,4.14,0,0,0-.88,1.39,5.54,5.54,0,0,1-1.63,2.49,3.47,3.47,0,0,1-2.85.57c-1-.19-2-.69-3.07-.45,1.07-.16,2,.4,3,.69a3.76,3.76,0,0,0,3.12-.5,5.58,5.58,0,0,0,1.83-2.61,3.67,3.67,0,0,1,.79-1.23,2.69,2.69,0,0,1,1.29-.59c1-.19,2-.11,3.1-.28a5.69,5.69,0,0,0,1.55-.48,3.26,3.26,0,0,0,1.28-1,6,6,0,0,0,1-3A14.21,14.21,0,0,0,232.12,281.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.31,282.29a10.51,10.51,0,0,0,.41,2.89,5.12,5.12,0,0,0,1.52,2.56,7.93,7.93,0,0,0,1.25.8,2.39,2.39,0,0,1,.92.92,7.53,7.53,0,0,0,.62,1.33,3.16,3.16,0,0,0,1.09,1,3.6,3.6,0,0,1-.89-1.1,7.38,7.38,0,0,1-.47-1.35,2.57,2.57,0,0,0-1-1.16,8.2,8.2,0,0,1-1.17-.78,5.51,5.51,0,0,1-1.48-2.31A22.62,22.62,0,0,1,232.31,282.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.45,299.62s-2.68-5.2-5-4.3-.74,8.11,1.66,9.39a2.59,2.59,0,0,0,3.63-.92Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,297.37a0,0,0,0,0,0,.07c1.68,1,2.39,2.73,2.81,4.52a1.43,1.43,0,0,0-2.07-.68s0,.11,0,.11a1.59,1.59,0,0,1,1.66.78,7.56,7.56,0,0,1,.65,1.52c.06.17.36.13.32-.06v-.05C213.68,301.33,212.35,297.93,210,297.37Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fire--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364,416.23s-35.09-5.13-37.2-3.78-4,11.59.23,14.08,36.4-2,36.4-2S367,421.41,364,416.23Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,416.23s-35.09-5.13-37.2-3.78-4,11.59.23,14.08,36.4-2,36.4-2S367,421.41,364,416.23Z",
    style: {
      opacity: 0.49
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,412.84c1.06-.24,2.77,3.28,2.38,7.19-.38,3.72-1.78,6.2-2.35,6.13s-2.55-2.25-2.22-7.05C325.07,415.62,326.13,413,327,412.84Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M330.7,413.82a50.87,50.87,0,0,1,6.05-.07c1,0,2,.13,3,.26a13.72,13.72,0,0,1,1.53.29c.54.14.93.24,1.44.33,1.93.33,3.94.47,5.93.65s4,.32,6,.51a55.53,55.53,0,0,1-6,.24,39.06,39.06,0,0,1-6.08-.45c-.49-.08-1.07-.25-1.5-.36s-.94-.21-1.43-.3c-1-.18-2-.29-3-.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M334.68,415.69c1.43.21,2.85.44,4.25.72s2.81.55,4.19.73a26.51,26.51,0,0,0,4.19.06c1.43-.06,2.86-.1,4.3-.11a32,32,0,0,1-4.23.86,17.33,17.33,0,0,1-4.39.15,30,30,0,0,1-4.24-1A35.2,35.2,0,0,1,334.68,415.69Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M351.91,419a12.19,12.19,0,0,1,6.32-2.33,7.77,7.77,0,0,1,3.45.57,4.48,4.48,0,0,1,1.53,1,2.51,2.51,0,0,1,.56.87,1.19,1.19,0,0,1,.06.37,1.1,1.1,0,0,1-.06.26c0,.06,0,.1-.07.15a2.29,2.29,0,0,1-.32.43,5.93,5.93,0,0,1-3.17,1.69,3.85,3.85,0,0,1-1.87-.14,8.72,8.72,0,0,1-1.59-.72,2.78,2.78,0,0,1-1.31-1.35.74.74,0,0,1,.09-.64.91.91,0,0,1,.45-.35,3.24,3.24,0,0,1,.88-.22,7.52,7.52,0,0,1,1.71,0,3.06,3.06,0,0,1,1.58.6,4.85,4.85,0,0,0-3.21-.14,2.9,2.9,0,0,0-.72.24c-.21.12-.25.19-.19.32a2.27,2.27,0,0,0,1.08.87,10,10,0,0,0,1.49.57,3,3,0,0,0,1.45,0,5.09,5.09,0,0,0,2.61-1.44,1.5,1.5,0,0,0,.19-.23l0,0a.06.06,0,0,0,0,.06s0,0,0,0a1.36,1.36,0,0,0-.34-.52,3.67,3.67,0,0,0-1.21-.85,7.67,7.67,0,0,0-3.06-.66,10.36,10.36,0,0,0-3.21.43A16.27,16.27,0,0,0,351.91,419Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M363.59,422.38a12.27,12.27,0,0,1-4.36,1.41,10.76,10.76,0,0,1-2.34,0,10.89,10.89,0,0,1-2.3-.56,30,30,0,0,1-4.1-2,14.28,14.28,0,0,0-4.19-1.46,9.77,9.77,0,0,1,4.51.78c1.42.58,2.73,1.29,4.11,1.77a10.57,10.57,0,0,0,4.25.67A20.53,20.53,0,0,0,363.59,422.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M329.4,425.38q2.72,0,5.4.06a37,37,0,0,0,5.3-.2,21.39,21.39,0,0,1,5.47-.28,40.9,40.9,0,0,1,5.4.59l-5.41.16a29.91,29.91,0,0,0-5.29.49,24.66,24.66,0,0,1-5.5,0A44,44,0,0,1,329.4,425.38Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M353.74,424.23c-1.5-.37-3-.76-4.48-1.07-.75-.16-1.5-.32-2.25-.42a5.57,5.57,0,0,0-2.19.05c-1.48.29-3,.62-4.52.88-.77.13-1.54.23-2.33.3a8.08,8.08,0,0,1-2.44-.1,18.93,18.93,0,0,1-2.27-.67,5.51,5.51,0,0,1-2.16-1.3,1.58,1.58,0,0,1-.35-.71,1.4,1.4,0,0,1,.1-.84,2,2,0,0,1,1.14-.9,7.78,7.78,0,0,1,2.39-.4,12.56,12.56,0,0,1,2.37.12,5.24,5.24,0,0,1,2.29.77.82.82,0,0,1,.41.62.69.69,0,0,1-.51.57,4.9,4.9,0,0,1-1.17.25,15,15,0,0,1-2.32.05,21.2,21.2,0,0,0,2.28-.31c.66-.13,1.83-.45,1-.8a4.85,4.85,0,0,0-2.08-.54,12.08,12.08,0,0,0-2.25,0,9,9,0,0,0-2.13.45,1.26,1.26,0,0,0-.64.47.52.52,0,0,0,.15.59,4.78,4.78,0,0,0,1.78,1,19.16,19.16,0,0,0,2.16.62,14,14,0,0,0,4.4-.16c1.52-.21,3-.53,4.56-.72a9.46,9.46,0,0,1,1.21-.08,7.58,7.58,0,0,1,1.19.16c.77.16,1.52.36,2.26.57C350.85,423.17,352.31,423.65,353.74,424.23Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M343.83,419.89c-2.06-.35-4-.89-6-1.43l-3-.8a14.4,14.4,0,0,0-3-.53,7,7,0,0,1,3.14-.21,20.09,20.09,0,0,1,3.07.61A24.26,24.26,0,0,1,343.83,419.89Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M359.19,416s35.15-4.75,37.24-3.37,3.88,11.62-.38,14.07-36.38-2.44-36.38-2.44S356.22,421.16,359.19,416Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.19,416s35.15-4.75,37.24-3.37,3.88,11.62-.38,14.07-36.38-2.44-36.38-2.44S356.22,421.16,359.19,416Z",
    style: {
      opacity: 0.49
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.25,413c-1.06-.25-2.81,3.24-2.46,7.16.33,3.72,1.7,6.22,2.28,6.15s2.57-2.22,2.3-7C398.17,415.82,397.13,413.24,396.25,413Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M360.45,423.24l6,.33c1,0,2,.1,3,.09.49,0,1,0,1.46-.06s1-.11,1.54-.11a39.24,39.24,0,0,1,6.06.58,56.77,56.77,0,0,1,5.93,1.25c-2-.15-4-.32-6-.5s-4-.36-6-.35a12.63,12.63,0,0,0-1.47.08c-.53,0-1,0-1.56,0-1-.05-2-.13-3-.25A50.51,50.51,0,0,1,360.45,423.24Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M364.11,423.14a35.68,35.68,0,0,1,4.17-1.13,32,32,0,0,1,4.3-.63,17.41,17.41,0,0,1,4.36.49,30.37,30.37,0,0,1,4.16,1.2c-1.44-.13-2.87-.28-4.28-.45a27.36,27.36,0,0,0-4.19-.27c-1.39.07-2.81.27-4.23.41S365.55,423.05,364.11,423.14Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M381.54,421.2a17.5,17.5,0,0,0,3,1.39,11,11,0,0,0,3.17.68,8,8,0,0,0,3.1-.42,3.84,3.84,0,0,0,1.27-.76,1.64,1.64,0,0,0,.39-.49s0-.05,0,0a.07.07,0,0,0,0,.06l0,0a2.83,2.83,0,0,0-.17-.25,5.23,5.23,0,0,0-2.5-1.64,3.06,3.06,0,0,0-1.44-.07,11.23,11.23,0,0,0-1.53.45,2.33,2.33,0,0,0-1.15.78c-.07.13,0,.2.16.34a3.43,3.43,0,0,0,.7.3,4.91,4.91,0,0,0,3.21.11,3,3,0,0,1-1.61.47,7.12,7.12,0,0,1-1.72-.12,3.29,3.29,0,0,1-.85-.29.89.89,0,0,1-.42-.38.76.76,0,0,1-.05-.64,2.81,2.81,0,0,1,1.42-1.25,8.71,8.71,0,0,1,1.64-.6,3.94,3.94,0,0,1,1.87,0,5.9,5.9,0,0,1,3,1.94,1.84,1.84,0,0,1,.28.45.69.69,0,0,1,.07.15,1.24,1.24,0,0,1,0,.27,1,1,0,0,1-.09.36,2.31,2.31,0,0,1-.62.82,4.54,4.54,0,0,1-1.6.92,7.84,7.84,0,0,1-3.49.3A12.2,12.2,0,0,1,381.54,421.2Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M393.45,418.72a21.17,21.17,0,0,0-4.35-1,10.51,10.51,0,0,0-4.29.34c-1.42.37-2.78,1-4.24,1.45a9.83,9.83,0,0,1-4.56.42,14.37,14.37,0,0,0,4.29-1.13,30.55,30.55,0,0,1,4.25-1.68,9.36,9.36,0,0,1,4.66-.15A12.26,12.26,0,0,1,393.45,418.72Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M372.43,415.36a42.33,42.33,0,0,1,5.36-.83,24.64,24.64,0,0,1,5.5,0,30.1,30.1,0,0,0,5.3.47l5.4.14a40.6,40.6,0,0,1-5.39.61,21.84,21.84,0,0,1-5.47-.26,37.06,37.06,0,0,0-5.3-.18C376,415.32,374.24,415.35,372.43,415.36Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M383.78,416.11c-1.48.47-3,.84-4.48,1.19-.75.15-1.52.29-2.3.39a7.84,7.84,0,0,1-1.2.06,8.74,8.74,0,0,1-1.19-.17c-1.53-.31-3-.74-4.49-1.07a13.73,13.73,0,0,0-4.38-.5,19.46,19.46,0,0,0-2.2.44,4.94,4.94,0,0,0-1.86.87.54.54,0,0,0-.19.58,1.33,1.33,0,0,0,.6.52,8.73,8.73,0,0,0,2.09.61,11.92,11.92,0,0,0,2.23.19,4.86,4.86,0,0,0,2.12-.38c.83-.28-.31-.69-1-.88s-1.48-.36-2.24-.49a16.16,16.16,0,0,1,2.3.24,4.44,4.44,0,0,1,1.15.34.66.66,0,0,1,.46.6.86.86,0,0,1-.45.6,5.29,5.29,0,0,1-2.35.58,12.52,12.52,0,0,1-2.37-.06,8.11,8.11,0,0,1-2.35-.59,1.94,1.94,0,0,1-1.06-1,1.33,1.33,0,0,1,0-.84,1.56,1.56,0,0,1,.41-.68,5.44,5.44,0,0,1,2.25-1.13,19,19,0,0,1,2.31-.49,8.23,8.23,0,0,1,2.44.09c.78.13,1.55.29,2.3.48,1.5.39,3,.83,4.44,1.23a5.57,5.57,0,0,0,2.18.23c.75-.05,1.51-.15,2.27-.25C380.74,416.64,382.26,416.36,383.78,416.11Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M373.56,419.67a24.42,24.42,0,0,1-5.93,1.9,20.16,20.16,0,0,1-3.11.37,6.86,6.86,0,0,1-3.11-.46,14.55,14.55,0,0,0,3-.29l3-.57A60.75,60.75,0,0,1,373.56,419.67Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M382.93,423.48c1.6.52,3.11,1,4.66,1.38a20.53,20.53,0,0,0,2.34.44c.79.11,1.59.13,2.43.19a6.65,6.65,0,0,1-2.46.57,9.45,9.45,0,0,1-2.54-.25,11.07,11.07,0,0,1-2.37-.88A8,8,0,0,1,382.93,423.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M361.9,419.14s-41.63,9.36-43.41,11.79.48,14.74,6.31,15.71,40-18,40-18S367.4,423.71,361.9,419.14Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.9,419.14s-41.63,9.36-43.41,11.79.48,14.74,6.31,15.71,40-18,40-18S367.4,423.71,361.9,419.14Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.85,431.29c1.09-.72,4.53,2.48,5.77,7,1.19,4.34.69,7.73,0,7.9s-3.82-1.43-5.52-7C317.86,435.25,317.94,431.9,318.85,431.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M323.41,430.81a64.87,64.87,0,0,1,6.8-2.61c1.15-.39,2.32-.72,3.52-1a15.18,15.18,0,0,1,1.83-.33c.65-.08,1.16-.12,1.76-.25,2.32-.45,4.64-1.18,6.95-1.85l7-2.09c-2.19,1.05-4.44,2-6.72,2.8a48.86,48.86,0,0,1-7,2.1c-.59.11-1.29.17-1.84.23s-1.16.18-1.74.29c-1.17.23-2.33.54-3.51.82s-2.33.62-3.49.95Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M328.69,431.19q2.55-.53,5.09-.95c1.69-.31,3.4-.57,5-1a30.4,30.4,0,0,0,4.75-1.77q2.35-1,4.75-2.05a42.69,42.69,0,0,1-4.42,2.73,21.5,21.5,0,0,1-4.85,2,39.67,39.67,0,0,1-5.16.77A49.81,49.81,0,0,1,328.69,431.19Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M349.47,427.47a14.87,14.87,0,0,1,6.12-5.27,9.3,9.3,0,0,1,4.09-.82,5.35,5.35,0,0,1,2.12.5,2.88,2.88,0,0,1,1,.71,1.22,1.22,0,0,1,.21.36,1.35,1.35,0,0,1,0,.29,1.24,1.24,0,0,0,0,.18,2.87,2.87,0,0,1-.17.6,7.05,7.05,0,0,1-2.79,3.22,4.45,4.45,0,0,1-2.11.64,10.37,10.37,0,0,1-2.08-.11,3.33,3.33,0,0,1-2-.92.81.81,0,0,1-.17-.71,1.16,1.16,0,0,1,.34-.56,4.49,4.49,0,0,1,.87-.62,8.62,8.62,0,0,1,1.92-.73,3.65,3.65,0,0,1,2,0,3.9,3.9,0,0,0-1.94.28,8.51,8.51,0,0,0-1.75.9c-.52.34-1.13.87-.81,1.11A2.91,2.91,0,0,0,356,427a12.43,12.43,0,0,0,1.93,0,3.6,3.6,0,0,0,1.69-.58,6.23,6.23,0,0,0,2.36-2.79,1.83,1.83,0,0,0,.11-.37v-.06a.06.06,0,0,0,0,0,.21.21,0,0,0-.05-.07,1.93,1.93,0,0,0-.64-.47,4.66,4.66,0,0,0-1.76-.44,9.6,9.6,0,0,0-3.76.6,13.37,13.37,0,0,0-3.42,1.9A19.82,19.82,0,0,0,349.47,427.47Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M364,426.25a15.24,15.24,0,0,1-4.32,3.39,13.94,13.94,0,0,1-2.6,1,12.79,12.79,0,0,1-2.8.36,39,39,0,0,1-5.46-.46,16.63,16.63,0,0,0-5.35.24,12.14,12.14,0,0,1,5.4-1c1.84.06,3.62.3,5.39.25a13.18,13.18,0,0,0,2.6-.28,14.85,14.85,0,0,0,2.49-.83A23.36,23.36,0,0,0,364,426.25Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M326.93,444.35l6.12-2.19a43.74,43.74,0,0,0,5.89-2.49,26.44,26.44,0,0,1,6-2.69,57.45,57.45,0,0,1,6.29-1.74l-6,2.44a36.6,36.6,0,0,0-5.76,2.82,29.88,29.88,0,0,1-6.16,2.37A57.34,57.34,0,0,1,326.93,444.35Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M353.78,432.57c-1.84.21-3.68.39-5.51.68-.91.14-1.82.28-2.71.48a6.92,6.92,0,0,0-2.46,1c-1.55,1-3.11,2-4.72,2.92-.8.47-1.62.92-2.48,1.33a9.72,9.72,0,0,1-2.75.95,24,24,0,0,1-2.82.21,6.57,6.57,0,0,1-2.93-.53,1.81,1.81,0,0,1-.67-.6,1.53,1.53,0,0,1-.23-.92,2.37,2.37,0,0,1,.85-1.45,9.38,9.38,0,0,1,2.48-1.47,16,16,0,0,1,2.69-.9,6.34,6.34,0,0,1,2.88-.14,1,1,0,0,1,.71.5.81.81,0,0,1-.32.82,5.54,5.54,0,0,1-1.19.78,20,20,0,0,1-2.57,1.09,25.88,25.88,0,0,0,2.44-1.31,5.86,5.86,0,0,0,1.06-.82c.15-.15.24-.35.19-.4a.75.75,0,0,0-.44-.2,6,6,0,0,0-2.6.28,14.39,14.39,0,0,0-2.53,1,10.1,10.1,0,0,0-2.23,1.42,1.57,1.57,0,0,0-.56.86.74.74,0,0,0,.46.71,6,6,0,0,0,2.5.37A24.61,24.61,0,0,0,333,439a16.68,16.68,0,0,0,4.92-2.09c1.61-.89,3.15-1.91,4.8-2.79a8.63,8.63,0,0,1,1.3-.61,9.48,9.48,0,0,1,1.4-.34c.93-.16,1.85-.27,2.78-.35C350.07,432.65,351.92,432.56,353.78,432.57Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M340.78,432c-2.47.42-4.93.64-7.38.89-1.23.12-2.45.25-3.67.4a14.87,14.87,0,0,0-3.59.78,8.59,8.59,0,0,1,3.45-1.53,27.59,27.59,0,0,1,3.71-.61A32.83,32.83,0,0,1,340.78,432Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M360.22,419.14s41.62,9.36,43.41,11.79-.49,14.74-6.32,15.71-40-18-40-18S354.71,423.71,360.22,419.14Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.22,419.14s41.62,9.36,43.41,11.79-.49,14.74-6.32,15.71-40-18-40-18S354.71,423.71,360.22,419.14Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.26,431.29c-1.09-.72-4.52,2.48-5.77,7-1.18,4.34-.68,7.73,0,7.9s3.83-1.43,5.53-7C404.26,435.25,404.17,431.9,403.26,431.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M358.61,427.83l3.32,1.49c1.1.51,2.2,1,3.31,1.48s2.21.95,3.33,1.36c.56.2,1.12.41,1.68.56s1.21.31,1.77.52a48.84,48.84,0,0,1,6.6,3.16c2.12,1.19,4.2,2.44,6.2,3.82l-6.54-3.16c-2.18-1-4.36-2.1-6.58-2.91-.58-.22-1.07-.34-1.7-.52a14.65,14.65,0,0,1-1.76-.62c-1.13-.47-2.24-1-3.32-1.54A67,67,0,0,1,358.61,427.83Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M362.78,429.24a49.6,49.6,0,0,1,5.16.55,41.46,41.46,0,0,1,5.1,1.11,21.52,21.52,0,0,1,4.7,2.35,42.14,42.14,0,0,1,4.23,3q-2.33-1.15-4.6-2.36a31.07,31.07,0,0,0-4.62-2.08c-1.61-.5-3.29-.88-5-1.3S364.45,429.71,362.78,429.24Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M383.26,434.35a19.87,19.87,0,0,0,2.78,2.87,13.11,13.11,0,0,0,3.29,2.12,9.39,9.39,0,0,0,3.71.86,4.63,4.63,0,0,0,1.79-.33,1.83,1.83,0,0,0,.67-.42l.05-.06s0,0,0,0v-.07a1.23,1.23,0,0,0-.09-.37,6.24,6.24,0,0,0-2.16-2.95,3.69,3.69,0,0,0-1.65-.69,12.38,12.38,0,0,0-1.92-.12,2.82,2.82,0,0,0-1.67.43c-.35.22.23.79.73,1.17a8.61,8.61,0,0,0,1.68,1,4,4,0,0,0,1.92.41,3.64,3.64,0,0,1-2-.17,9,9,0,0,1-1.87-.86,4.76,4.76,0,0,1-.83-.68,1.23,1.23,0,0,1-.3-.58.82.82,0,0,1,.22-.7,3.29,3.29,0,0,1,2.08-.78,9.64,9.64,0,0,1,2.08,0,4.43,4.43,0,0,1,2.06.78,7,7,0,0,1,2.57,3.4,2.41,2.41,0,0,1,.13.61,1.08,1.08,0,0,1,0,.18,1.36,1.36,0,0,1-.06.29,1.19,1.19,0,0,1-.24.34,2.86,2.86,0,0,1-1,.64,5.21,5.21,0,0,1-2.15.36,9.29,9.29,0,0,1-4-1.1A14.76,14.76,0,0,1,383.26,434.35Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M397.72,436.54a23.87,23.87,0,0,0-4.46-3,15,15,0,0,0-2.43-1,12.89,12.89,0,0,0-2.58-.45c-1.76-.17-3.55,0-5.39-.12a12.05,12.05,0,0,1-5.32-1.35,16.33,16.33,0,0,0,5.32.59,39.93,39.93,0,0,1,5.48-.08,12,12,0,0,1,2.76.54,13.38,13.38,0,0,1,2.53,1.21A15.09,15.09,0,0,1,397.72,436.54Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M375.42,424a57.85,57.85,0,0,1,6.37,1.39,29.23,29.23,0,0,1,6.19,2.28,37,37,0,0,0,5.8,2.73l6.07,2.35a57.54,57.54,0,0,1-6.32-1.65,25.89,25.89,0,0,1-6-2.59,43.25,43.25,0,0,0-5.93-2.41Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M387.9,429.55c-1.85-.11-3.69-.33-5.53-.58-.92-.15-1.83-.31-2.75-.54a9,9,0,0,1-1.37-.43,10.77,10.77,0,0,1-1.26-.69c-1.59-1-3.06-2.11-4.6-3.12a16.75,16.75,0,0,0-4.77-2.41,24.46,24.46,0,0,0-2.68-.42,6,6,0,0,0-2.51.2.73.73,0,0,0-.51.68,1.62,1.62,0,0,0,.49.9,10.53,10.53,0,0,0,2.13,1.56,14.88,14.88,0,0,0,2.46,1.15,6.07,6.07,0,0,0,2.58.45.74.74,0,0,0,.45-.17c.05-.05,0-.25-.16-.41a5.39,5.39,0,0,0-1-.89c-.75-.53-1.54-1-2.35-1.47a19.37,19.37,0,0,1,2.49,1.26,5.51,5.51,0,0,1,1.14.86.79.79,0,0,1,.26.83,1,1,0,0,1-.74.45,6.23,6.23,0,0,1-2.86-.33,15.32,15.32,0,0,1-2.62-1.07,9.28,9.28,0,0,1-2.38-1.64,2.3,2.3,0,0,1-.75-1.5,1.51,1.51,0,0,1,.29-.9,1.88,1.88,0,0,1,.71-.56,6.47,6.47,0,0,1,2.95-.33,23.76,23.76,0,0,1,2.81.4A10.05,10.05,0,0,1,370.5,422c.82.47,1.61,1,2.38,1.5,1.54,1.05,3,2.16,4.52,3.22a6.76,6.76,0,0,0,2.38,1.16c.88.26,1.78.47,2.68.66C384.26,428.91,386.08,429.22,387.9,429.55Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M374.89,429.28a33.38,33.38,0,0,1-7.47-.42,29,29,0,0,1-3.66-.87,8.54,8.54,0,0,1-3.33-1.75,15.08,15.08,0,0,0,3.52,1c1.21.22,2.42.44,3.63.64C370,428.31,372.45,428.7,374.89,429.28Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M383.86,437.51a49.12,49.12,0,0,0,4.62,3.59,22.85,22.85,0,0,0,2.49,1.46,28.64,28.64,0,0,0,2.69,1.16,8.5,8.5,0,0,1-3-.46,11.51,11.51,0,0,1-2.72-1.35,14.08,14.08,0,0,1-2.32-2A10.64,10.64,0,0,1,383.86,437.51Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M326.76,324.88a1.36,1.36,0,1,1-1.35-1.35A1.36,1.36,0,0,1,326.76,324.88Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.95,
    cy: 266.56,
    r: 1.36,
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.23,316a1.36,1.36,0,1,1,.25-1.9A1.36,1.36,0,0,1,393.23,316Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.4,399a1.36,1.36,0,1,1-1.36-1.35A1.36,1.36,0,0,1,405.4,399Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.15,
    cy: 389.76,
    r: 1.36,
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.6,333.76a1.84,1.84,0,1,1-1.84-1.84A1.84,1.84,0,0,1,328.6,333.76Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.85,300.8a1.84,1.84,0,1,1,.34-2.58A1.84,1.84,0,0,1,385.85,300.8Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.92,368.81a1.84,1.84,0,1,1-1.84-1.84A1.83,1.83,0,0,1,401.92,368.81Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.52,331.13a.8.8,0,0,1-.8.8.79.79,0,0,1-.79-.8.79.79,0,0,1,.79-.79A.79.79,0,0,1,331.52,331.13Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.74,356.9a.8.8,0,0,1-1.6,0,.8.8,0,1,1,1.6,0Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.34,382.46a.79.79,0,0,1-.79.8.8.8,0,0,1-.8-.8.79.79,0,0,1,.8-.79A.79.79,0,0,1,314.34,382.46Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.58,363.1a.79.79,0,0,1-.79.8.8.8,0,0,1-.8-.8.79.79,0,0,1,.8-.79A.79.79,0,0,1,404.58,363.1Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.74,305.93a.79.79,0,0,1-.79.79.79.79,0,0,1-.8-.79.8.8,0,0,1,.8-.8A.79.79,0,0,1,320.74,305.93Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.4,298.55a.79.79,0,0,1-.79.8.8.8,0,0,1,0-1.6A.79.79,0,0,1,357.4,298.55Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.39,286.55a.8.8,0,1,1-1.6,0,.8.8,0,0,1,1.6,0Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,409.62c-.27-2.74-2.43-7.47-2.87-9.51s2.4-8.1,1.84-10.58-5.41-8.14-5.41-8.14.42,6.26,0,7-1.8,2.22-2.13,2,2.55-12.41,2.08-16.15-9-18-7.88-15.7,3.66,11.94,3.4,13.86-4.09,9.72-5,13.31,1.41,9.33,1.28,10.1-3.71,0-5.37-1.79,1.27-11,2.16-13.44-2.42-15.09-3.66-16.75-13.35-4.1-14-5.63,4.73-7.67,4.22-9.08-5.89-4.23-7.36-6,0-9.34,0-9.34-8.5,13.69-8.89,17.66,2.3,7,2.6,8.18-3.11,10.87-4.39,12-4.22,2.55-7.11,4.34-4.29,7.42-4.29,7.42c-.27-2.43,2.44-7.93,2.66-9.59s-5.84-13.56-5.62-15.22,4.51-7,4.81-9.34-9.1-12.16-9.1-12.16,4.32,11.26,3.3,14.34-12.41,22.12-12.15,26,3.07,15.48,2.95,17.39-4.23,11.64-3.55,14.34S332.61,421,334.71,422.4s6.72-.64,8.64,0,15.26,3.84,15.26,3.84l5.34-.08s20.42-2.64,26.09-6.23C392.07,418.64,399.46,412.34,399.21,409.62Zm-64.77-18.77s2.9,4.06,2,7.21-1.83,4.56-1.79,6.14.64,5.58.64,5.58c-.26-.21-3-5.66-3.15-8.14C331.87,398.4,334.44,390.85,334.44,390.85Zm1.83,29.21c-1.79-.94-7.33-5.93-7.93-8.18s.63-9.3.63-9.3,1.38,6.95,2.25,8.4,5.69,3.58,7.31,5.07,4.9,4.31,4.9,4.31S338.06,421,336.27,420.06Zm47.88-7.76c-1,4.18-6.65,6.82-6.65,6.82a29.13,29.13,0,0,1,2.13-5.67c1-1.57,2.44-4.6,2.3-7s-2.61-7-2.8-7.3C379.46,399.6,385.1,408.25,384.15,412.3Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.77,339.5s-5.87-4.18-6-7.33,3.68-9.72,3.29-12.28a17.36,17.36,0,0,0-1.69-4.95s6.21,4.27,6.19,7.76-3.7,9-3.36,10.75S340.77,339.5,340.77,339.5Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.84,358.7s-1.37-4.15-1.17-5.8,2.15-3.81,2.15-3.81a4.55,4.55,0,0,1,.79,4.3C376.84,356.06,375.84,358.7,375.84,358.7Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.36,358a23.44,23.44,0,0,1-3.36-8.91c-.45-4,1.69-9.13,2.43-10.44s3.84-3.07,3.84-3.07-2.11,3.33-2.18,4.83,1.06,6.17,1.22,8S390.36,358,390.36,358Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.24,333.76s-4.42-6-3.58-9.91,4.25-9,5.56-10.3,4.54-4.42,5.88-6.53,1.41-9.78,0-11.7a11.66,11.66,0,0,0-3.83-3.09,12.18,12.18,0,0,1,9.85,5.07c3.83,5.38,8.76,26.23,6.46,31s-8.77,9.4-8.77,9.4,1.73-8.25,1.16-10.3-6.72,0-8.26,1.25A44.07,44.07,0,0,0,352.24,333.76Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09,363.24s-2.71-2.81-2.13-5.24,4-6.08,4.22-7.23-.8-5.83-.8-5.83,3.48,6.6,2.72,8.65a48.55,48.55,0,0,0-1.47,5.11s1.53-1,1.85-1.85a20.88,20.88,0,0,0,.64-2.24s2.62,3.26,1.79,5.56-5.37,6.72-5.37,6.72a15,15,0,0,0,.06-2.11C343.54,364,343.05,364.45,342.09,363.24Z",
    style: {
      fill: "#F79F1F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.86,426.16s-16-5.75-19.56-13.94c-2.23-5.13,3.8-15.63,4.31-17.29s-.16-8.06.69-10.62,12.17-9.27,13.16-11-2-8.8-2-8.8,8.6,7,9.88,10.9-3.83,11.61-3.77,13,3,5.58,3,5.58,2.27-2.89,2.35-5.58-1.24-4.08-1-5.94,3.75-5.44,3.75-5.44-1.81,3.21-.91,5.44,5.25,6.58,4.61,10-5.76,11.38-5.31,13.56a10.15,10.15,0,0,0,1.61,3.72,36.35,36.35,0,0,0,1.84-5.4c.45-2.16.92-5,.92-5s2.63,14.2-.08,18.2S360.86,426.16,360.86,426.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.61,327.22c-.13-.25-1.85-4.12-1.92-6.23s3.78-4.92,5.5-6.52,5.44-6.78,5.12-9.47-.72-4.73-.72-4.73,5.32,15.22,5,20a13.91,13.91,0,0,1-3.13,7.86s-1-4.62-3.26-4.47C360.19,323.87,356.61,327.22,356.61,327.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.38,337.41s-3.41-3.2-3.37-5.33,3.37-8.06,3.37-8.06-1.43,7-1.68,8.31S339.38,337.41,339.38,337.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.88,421.15s6.94-4.32,8.21-5.46,3.18-7.24,3.05-8.46-2.37-6.63-2.37-8.12,4.55-6.81,4.55-6.81-1.48,5-1.22,6.26,6.17,8.26,5.81,10.89-6,7.36-7.62,8.42S378.88,421.15,378.88,421.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.93,393.18s-4.61-11.94-4.19-15.1S331.52,363,331.52,363s-.39,10.19-.82,11.79.82,6.46.82,6.46a42.1,42.1,0,0,0,1.94-4.78c.3-1.27-.91-6.22-.91-6.22s3.34,8.84,2.57,12.22S329.93,393.18,329.93,393.18Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog2);
export default __webpack_public_path__ + "static/media/blog-2.6c72a53a755f91063865850e53e134ce.svg";
export { ForwardRef as ReactComponent };